/*
  Orvenisa · JS của LP sản phẩm (layout/orv-lp.liquid, sections/orv-lp.liquid).
  Chép từ LP Cepillo v3.8. Khác bản gốc:
  - Mã variant + giá đọc từ trang (data-variant / value) do Liquid in ra từ Shopify, không gõ cứng.
  - Số lượng mặc định = gói được chọn sẵn (data-qty ở .packs).
  - Giá gạch = Compare-at price của variant (data-antes). Toast đơn ảo, thanh "Bajo stock", đồng hồ chỉ chạy khi section bật (không có phần tử thì tự bỏ qua).
  - Chạy lại khi Theme Editor tải lại section.
*/
(function(){
function orvLP(){
// Video tải chậm: <video data-src preload="none"> (snippet orv-lp-media) → gán src lần đầu cần chạy, rồi play().
function posterVid(v){ var u=v.getAttribute('data-poster'); if(u){ v.setAttribute('poster',u); v.removeAttribute('data-poster'); } }
function cargarVid(v){ posterVid(v); var u=v.getAttribute('data-src'); if(u && !v.getAttribute('src')){ v.src=u; } }
function playVid(v){ cargarVid(v); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
// Ảnh slide chưa nạp: <img data-src data-srcset> (snippet orv-lp-slide-img) → gán srcset/src khi cần.
function cargarImg(el){
  if(!el) return;
  if(el.tagName!=='IMG'){ el.querySelectorAll('video[data-poster]').forEach(posterVid); return; }   // slide video → chỉ gắn ảnh bìa
  var ss=el.getAttribute('data-srcset'), u=el.getAttribute('data-src');
  if(ss){ el.setAttribute('srcset',ss); el.removeAttribute('data-srcset'); }
  if(u){ el.setAttribute('src',u); el.removeAttribute('data-src'); }
}
// Chạy fn khi trang đã tải xong (window load) và trình duyệt rảnh → không tranh băng thông với ảnh LCP.
function trasCarga(fn){
  function idle(){ if(window.requestIdleCallback) requestIdleCallback(fn,{timeout:2000}); else setTimeout(fn,200); }
  if(document.readyState==='complete') idle(); else window.addEventListener('load',idle,{once:true});
}
// Gói ứng với số lượng q: gói có data-uds=q; không có → gói có q trong data-tambien (vd Guantes: gói 2 cũng dùng cho 3).
function packDe(q){
  var ins=document.querySelectorAll('.packs input'), i, j, t;
  for(i=0;i<ins.length;i++) if(parseInt(ins[i].getAttribute('data-uds'),10)===q) return ins[i];
  for(i=0;i<ins.length;i++){ t=(ins[i].getAttribute('data-tambien')||'').split(',');
    for(j=0;j<t.length;j++) if(parseInt(t[j],10)===q) return ins[i]; }
  return null;
}
// Ô số lượng có variant ĐƠN GIÁ (data-variant: classic v3 "3+" / lp_config.stepper → v1)? Không → chế độ GHÉP GÓI.
function masUnidad(){ var m=document.querySelector('.mas-uds'); return (m&&m.getAttribute('data-variant'))?m:null; }
// Tổ hợp mua cho q món → [{id, n, precio, antes}] (precio/antes = giá 1 lần của dòng đó; antes 0 = không có compare-at).
//  q khớp gói (data-uds / data-tambien) → gói đó ×1 · có variant đơn giá → variant đó × q
//  · không có → ghép gói: lấy tối đa gói lớn nhất, phần dư lấy gói nhỏ hơn (lùi lại nếu không ghép vừa).
function comboDe(q){
  var r=packDe(q);
  function linea(el,n,pre){ return {id:el.getAttribute('data-variant'), n:n, precio:parseFloat(pre)||0, antes:parseFloat(el.getAttribute('data-antes'))||0}; }
  if(r) return [linea(r,1,r.value)];
  var m=masUnidad();
  if(m) return [linea(m,q,m.getAttribute('data-unit'))];
  var ps=[].slice.call(document.querySelectorAll('.packs input')).map(function(el){ return {el:el, u:parseInt(el.getAttribute('data-uds'),10)||0}; })
    .filter(function(x){ return x.u>0; }).sort(function(a,b){ return b.u-a.u; });
  function ghep(i,resto){
    if(resto===0) return [];
    if(i>=ps.length) return null;
    for(var k=Math.floor(resto/ps[i].u);k>=0;k--){
      var sig=ghep(i+1,resto-k*ps[i].u);
      if(sig) return k>0?[linea(ps[i].el,k,ps[i].el.value)].concat(sig):sig;
    }
    return null;
  }
  return ghep(0,q)||[];
}
// Tổng giá / tổng giá gạch của tổ hợp (thiếu compare-at ở bất kỳ dòng nào → giá gạch 0 = ẩn)
function totalDe(c){ var t=0; c.forEach(function(x){ t+=x.n*x.precio; }); return Math.round(t*100)/100; }
function antesDe(c){ var t=0, ok=c.length>0; c.forEach(function(x){ if(!x.antes) ok=false; t+=x.n*x.antes; }); return ok?Math.round(t*100)/100:0; }
// REGALO (lp_config.regalo, snippet orv-lp-regalo): quà theo gói — phần tử i của por_pack / valor_por_pack ↔ product.variants[i].
// REGALOS (lp_config.regalos, snippet orv-lp-regalos, #rgs-panel[data-rgs-carrito]): quà GIỐNG NHAU cho mọi variant của SP đang xem
// → RG.modo "regalos" (chỉ gửi property, không vẽ lại gì trên trang).
// Không có [data-regalo] và không có #rgs-panel[data-rgs-carrito] → RG = null, mọi hàm dưới trả rỗng → trang + luồng mua y như cũ.
var RG=(function(){
  var r=document.querySelector('[data-regalo]');
  if(!r){
    var q=document.querySelector('#rgs-panel[data-rgs-carrito]'), car=q&&q.getAttribute('data-rgs-carrito');
    if(!car) return null;
    var qv; try{ qv=JSON.parse(q.getAttribute('data-vids'))||[]; }catch(e){ qv=[]; }
    return {modo:'regalos', vids:qv.map(String), its:[], car:car, v:rgCent(q.getAttribute('data-rgs-valor')),
      img:q.getAttribute('data-rgs-img')||'', badge:q.getAttribute('data-badge')||'GRATIS'};
  }
  var vids; try{ vids=JSON.parse(r.getAttribute('data-vids'))||[]; }catch(e){ vids=[]; }
  var its=[].slice.call(r.querySelectorAll('[data-rg-pp]')).map(function(el){
    var pp=[], vv=[];
    try{ pp=JSON.parse(el.getAttribute('data-rg-pp'))||[]; }catch(e){}
    try{ vv=JSON.parse(el.getAttribute('data-rg-vv'))||[]; }catch(e){}
    return {el:el, pp:pp, vv:vv, img:el.getAttribute('data-rg-img')||''};
  });
  return {vids:vids.map(String), its:its, badge:r.getAttribute('data-badge')||'GRATIS'};
})();
// "12,00 €" / "1.200,50 €" / "12.5" → cent
function rgCent(t){
  t=String(t==null?'':t).replace(/[^\d,.]/g,'');
  if(t.indexOf(',')>-1) t=t.replace(/\./g,'').replace(',','.');
  var n=parseFloat(t); return isNaN(n)?0:Math.round(n*100);
}
function rgEur(c){ return (c/100).toFixed(2).replace('.',',')+' €'; }
// Gộp quà theo SỐ LƯỢNG: [{t:"4 filtros de recambio", n:2}, {t:"12 filtros de recambio", n:1}] → "20 filtros de recambio".
// Mọi phần cùng dạng "<số> <tên giống nhau>" → cộng số; không cùng dạng → "2 × A + B".
function rgSuma(ps){
  var tot=0, resto=null, ok=ps.length>0;
  ps.forEach(function(p){ var m=String(p.t).match(/^\s*(\d+)\s+(.+)$/);
    if(!m||(resto!==null&&m[2]!==resto)){ ok=false; return; } resto=m[2]; tot+=parseInt(m[1],10)*p.n; });
  if(ok) return tot+' '+resto;
  return ps.map(function(p){ return (p.n>1?p.n+' × ':'')+p.t; }).join(' + ');
}
// Quà của 1 dòng (variant id) cho 1 item quà: {t, v(cent/1 món)} hoặc null
function rgDe(it,id){
  if(!RG) return null;
  var k=RG.vids.indexOf(String(id)); if(k<0) return null;
  var t=it.pp[k]; if(!t) return null;
  return {t:String(t), v:rgCent(it.vv[k]), s:it.vv[k]||''};
}
// line item properties cho variant id: {"Regalo": "4 filtros de recambio", "_regalo_valor": "1200", "_regalo_img": url?} hoặc null
// ("_…" = ẩn ở checkout/đơn; chỉ ngăn giỏ LP dùng để vẽ dòng quà)
function rgProps(id){
  if(!RG) return null;
  if(RG.modo==='regalos'){
    if(RG.vids.indexOf(String(id))<0) return null;   // SP khác / SP bảo vệ → không có quà
    var q={'Regalo':RG.car}; if(RG.v) q._regalo_valor=String(RG.v); if(RG.img) q._regalo_img=RG.img;
    return q;
  }
  var ts=[], v=0, img='';
  RG.its.forEach(function(it){ var g=rgDe(it,id); if(g){ ts.push(g.t); v+=g.v; if(!img) img=it.img; } });
  if(!ts.length) return null;
  var p={'Regalo':ts.join(' + ')}; if(v) p._regalo_valor=String(v); if(img) p._regalo_img=img;
  return p;
}
// COLOR (lp_config.colores, snippet orv-lp-colores, [data-colores]): MỖI MÓN 1 MÀU (hàng "#1 / #2 / #3", số hàng = số món đang chọn).
// Màu KHÔNG phải variant → line item property "<prop>": "Luz cálida" (1 món) / "1× Luz cálida + 1× Multicolor" cho mọi variant
// của SP đang xem (data-vids). Không có [data-colores] → COL = null → propsDe = rgProps → trang + luồng mua y như cũ.
var COL=(function(){
  var f=document.querySelector('[data-colores]'); if(!f) return null;
  var vids, items; try{ vids=JSON.parse(f.getAttribute('data-vids'))||[]; }catch(e){ vids=[]; }
  try{ items=JSON.parse(f.getAttribute('data-items'))||[]; }catch(e){ items=[]; }
  var imgs; try{ imgs=JSON.parse(f.getAttribute('data-imgs')||'[]')||[]; }catch(e){ imgs=[]; }
  var d=f.getAttribute('data-def')||items[0]||'', o={el:f, prop:f.getAttribute('data-prop')||'Color', vids:vids.map(String), items:items, def:d, cols:[], q:1,
    deb:f.classList.contains('co-debajo'), tit:f.getAttribute('data-tit')||'', titV:f.getAttribute('data-tit-v')||'', imgs:imgs, imgOrig:{}};   // deb: lp_config.colores.debajo
  [].forEach.call(document.querySelectorAll('.co-pk select'),function(se){ o.cols[+se.getAttribute('data-co-i')]=se.value||d; });   // dropdown in sẵn
  return o;
})();
// Số món của 1 variant của trang (gói: max(data-uds, data-tambien); ô đơn giá / khác: 1)
function udsVar(id){
  var u=0;
  [].forEach.call(document.querySelectorAll('.packs input'),function(el){
    if(el.getAttribute('data-variant')!==String(id)) return;
    u=parseInt(el.getAttribute('data-uds'),10)||0;
    (el.getAttribute('data-tambien')||'').split(',').forEach(function(t){ t=parseInt(t,10); if(t>u) u=t; });
  });
  return u||1;
}
// ["Luz cálida","Multicolor","Luz cálida"] → "2× Luz cálida + 1× Multicolor" (1 món → "Luz cálida"; trống → '')
function colTxt(a){
  a=a.filter(function(x){ return x; }); if(!a.length) return '';
  if(a.length===1) return a[0];
  var ord=[], n={}; a.forEach(function(x){ if(!n[x]){ n[x]=0; ord.push(x); } n[x]++; });
  return ord.map(function(x){ return n[x]+'× '+x; }).join(' + ');
}
// ngược lại: chuỗi property → danh sách đúng `u` món (thiếu → lặp màu cuối / '')
function colLista(t,u){
  var a=[]; t=String(t||'');
  if(t) t.split(' + ').forEach(function(p){ var m=p.match(/^\s*(\d+)\s*×\s*(.+?)\s*$/); if(m){ for(var i=0;i<+m[1];i++) a.push(m[2]); } else a.push(p.trim()); });
  if(a.length===1&&u>1) while(a.length<u) a.push(a[0]);
  while(a.length<u) a.push(a.length?a[a.length-1]:'');
  return a.slice(0,u);
}
// Chia danh sách màu (mỗi món 1 màu) cho các dòng của tổ hợp c = [{id,n}] → [chuỗi property] theo thứ tự c.
// Gom cùng màu lại với nhau trước (ít dòng lẫn màu nhất cho kho).
function colReparto(c,cols){
  // chỉ dòng có variant chọn màu (COL.vids) mới nhận màu; dòng khác (lp_config.colores.packs) → '' và không tiêu màu
  cols=cols.filter(function(x){ return x; });
  var ord=[], g={}; cols.forEach(function(x){ if(!g[x]){ g[x]=[]; ord.push(x); } g[x].push(x); });
  var todo=[]; ord.forEach(function(x){ todo=todo.concat(g[x]); });
  var k=0;
  return c.map(function(x){
    if(!colEs(x.id)) return '';
    var u=udsVar(x.id)*x.n, t=todo.slice(k,k+u); k+=u;
    while(t.length<u) t.push(t.length?t[t.length-1]:COL.def);
    return colTxt(t);
  });
}
// variant có ô chọn màu? (data-vids; lp_config.colores.packs giới hạn)
function colEs(id){ return !!COL&&COL.vids.indexOf(String(id))>-1; }
// số món CẦN chọn màu trong tổ hợp của q món
function colQ(q){ var n=0; comboDe(q).forEach(function(x){ if(colEs(x.id)) n+=udsVar(x.id)*x.n; }); return n; }
// Màu đang chọn trên trang cho q món
function colSel(q){ q=colQ(q); var a=COL.cols.slice(0,q); while(a.length<q) a.push(a.length?a[a.length-1]:COL.def); return a; }
// Màu của 1 dòng giỏ (chuỗi property, '' = không có)
function colorDe(it){ return COL?String((it.properties||{})[COL.prop]||''):''; }
// properties cho 1 dòng mua = màu (chuỗi đã chia) + quà (rgProps). null khi không có gì.
function propsDe(id,txt){
  var p=rgProps(id);
  if(COL&&txt&&COL.vids.indexOf(String(id))>-1){ var q={}; q[COL.prop]=txt; if(p) for(var k in p) q[k]=p[k]; p=q; }
  return p;
}
// "#1 [select] … #q [select]" TRONG thẻ gói đang chọn (q món; không khớp gói nào — ghép gói — → ngay dưới .packs).
// Giữ màu đã chọn khi đổi gói; món mới lấy màu của món cuối (hoặc màu mặc định).
function colPintar(q){
  if(!COL) return;
  var qT=Math.max(1,q||1); q=colQ(qT);
  if(!q){   // tổ hợp không có món nào chọn màu (lp_config.colores.packs) → bỏ ô chọn
    var c0=document.querySelector('.co-pk'); if(c0) c0.parentNode.removeChild(c0);
    var l0=document.querySelector('.co-libre'); if(l0) l0.hidden=true;
    COL.q=0; return;
  }
  COL.q=q;
  for(var i=0;i<q;i++) if(!COL.cols[i]) COL.cols[i]=COL.cols[i-1]||COL.def;
  var cur=document.querySelector('.co-pk'), pk=COL.deb?null:packDe(qT), host;   // debajo: luôn ở ô riêng dưới .packs
  if(pk&&!colEs(pk.getAttribute('data-variant'))) pk=null;   // gói đang chọn không chọn màu (ghép) → ô riêng dưới .packs
  if(pk) host=pk.closest('.pack').querySelector('.info')||pk.closest('.pack');
  else{
    host=document.querySelector('.co-libre');
    if(!host){ var bx=document.querySelector('.packs'); host=document.createElement('div'); host.className='co-libre'; if(bx) bx.parentNode.insertBefore(host,bx.nextSibling); }
  }
  if(cur&&(cur.parentNode!==host||cur.querySelectorAll('select').length!==q)){ cur.parentNode.removeChild(cur); cur=null; }
  if(!cur){
    cur=document.createElement('span'); cur.className='co-pk';
    for(i=0;i<q;i++){
      var fi=document.createElement('span'); fi.className='co-sf';
      var n=document.createElement('span'); n.className='co-sn'; n.textContent='#'+(i+1);
      var se=document.createElement('select'); se.setAttribute('data-co-i',i); se.setAttribute('aria-label',COL.prop+' #'+(i+1));
      COL.items.forEach(function(v){ var o=document.createElement('option'); o.value=v; o.textContent=v; se.appendChild(o); });
      fi.appendChild(n); fi.appendChild(se); cur.appendChild(fi);
    }
    host.appendChild(cur);
  }
  [].forEach.call(cur.querySelectorAll('select'),function(se){ se.value=COL.cols[+se.getAttribute('data-co-i')]; });
  var lib=document.querySelector('.co-libre'); if(lib) lib.hidden=!!pk;
  if(COL.deb&&lib){
    // tiêu đề ô: titulo (1 món) / titulo_varios (≥ 2 món); ô dựng bằng JS (ghép gói lúc chưa có) → thêm lớp co-deb + thẻ tiêu đề
    lib.classList.add('co-deb');
    var tt=lib.querySelector('.co-tit');
    if(!tt){ tt=document.createElement('b'); tt.className='co-tit'; lib.insertBefore(tt,lib.firstChild); }
    var tx=q>1?(COL.titV||COL.tit):COL.tit; tt.textContent=tx; tt.hidden=!tx;
  }
}
// lp_config.colores.items[i].img → ảnh của các gói chọn màu đổi theo mẫu ở ô #1 (không có ảnh → giữ ảnh gốc của gói)
function colFoto(){
  if(!COL||!COL.imgs.length) return;
  var k=COL.items.indexOf(COL.cols[0]||COL.def), src=k>-1?COL.imgs[k]:'';
  [].forEach.call(document.querySelectorAll('.packs input'),function(el){
    var id=el.getAttribute('data-variant'); if(!colEs(id)) return;
    var im=el.closest('.pack')&&el.closest('.pack').querySelector('.pk-foto img'); if(!im) return;
    if(!(id in COL.imgOrig)) COL.imgOrig[id]=im.getAttribute('src');
    im.setAttribute('src',src||COL.imgOrig[id]); im.removeAttribute('srcset');
  });
}
if(COL){
  // dropdown #n (select = phần tử tương tác → bấm vào không kích hoạt <label> gói)
  document.addEventListener('change',function(e){
    var se=e.target; if(!se||!se.matches||!se.matches('.co-pk select')) return;
    COL.cols[+se.getAttribute('data-co-i')]=se.value;
    colFoto();
  });
  colFoto();
}
// Vẽ lại tên quà + giá gạch theo tổ hợp đang chọn c = comboDe(q)
function rgPintar(c){
  if(!RG||RG.modo==='regalos') return;
  RG.its.forEach(function(it){
    var ts=[], v=0, s='', n=0;
    c.forEach(function(x){ var g=rgDe(it,x.id); if(g){ n++; ts.push({t:g.t,n:x.n}); v+=g.v*x.n; s=x.n>1?'':g.s; } });
    var nom=it.el.querySelector('.rg-nom'), val=it.el.querySelector('.rg-val');
    if(ts.length) nom.textContent=rgSuma(ts);
    var txt=(n===1&&s)?s:(v?rgEur(v):'');
    if(val){ val.textContent=txt; val.hidden=!txt; }
  });
}
(function(){

  // ── ĐỊNH DẠNG TIỀN — sửa 1 chỗ duy nhất cho cả trang ──
  var CUR_SYM='€';   // €      // VD: '€'  ·  'zł'  ·  'lei'  ·  '₫'
  var CUR_DEC=',';   // ,     // VD: ','  (EU)  ·  '.'  (US)
  var CUR_POS='sau'; // sau → 'sau' = 59,90 € | 'truoc' = €59.90    // 'sau' = 59,90 €   ·   'truoc' = €59.90
  var CUR_LE = 2;                      // 2 → 2 (EUR/PLN/RON) · 0 (VND/HUF)
  function eur(v){
    var n=Number(v).toFixed(CUR_LE).replace('.',CUR_DEC);
    return CUR_POS==='truoc' ? CUR_SYM+n : n+' '+CUR_SYM;
  }

  // ── MỘT SỐ LƯỢNG DUY NHẤT (1–100), đồng bộ box + 2 form ──
  var packs=document.querySelectorAll('.packs .pack');
  var masU=document.querySelector('.mas-uds');
  var PASO=masU?parseInt(masU.getAttribute('data-paso'),10)||1:1;          // bước nhảy –/+ (ghép gói: số món gói nhỏ nhất)
  var MINQ=masU?parseInt(masU.getAttribute('data-min'),10)||1:1;
  var MAXQ=masU?parseInt(masU.getAttribute('data-max'),10)||100:100;

  // bảng combo theo số lượng: {uds: {precio, titulo}}
  var COMBO={};
  packs.forEach(function(p){
    var r=p.querySelector('input'), u=parseInt(r.getAttribute('data-uds'),10);
    if(u) COMBO[u]={precio:parseFloat(r.value), titulo:p.querySelector('.tit').textContent};
  });
  packs.forEach(function(p){
    var r=p.querySelector('input'), u=parseInt(r.getAttribute('data-uds'),10);
    (r.getAttribute('data-tambien')||'').split(',').forEach(function(x){ var k=parseInt(x,10); if(k&&!COMBO[k]&&COMBO[u]) COMBO[k]=COMBO[u]; });
  });

  function precioDe(q){ return COMBO[q]? COMBO[q].precio : totalDe(comboDe(q)); }
  function tituloDe(q){ return COMBO[q]? COMBO[q].titulo : q+' uds'; }

  var packsBox=document.querySelector('.packs');
  var qty=packsBox?parseInt(packsBox.getAttribute('data-qty'),10)||1:1; // mặc định = gói được chọn sẵn

  // PROTECCIÓN DE ENVÍO (lp_config.proteccion, snippet orv-lp-proteccion): ô tích, mặc định TẮT; bật → +giá ở nút CTA + [data-total]
  var protEl=document.querySelector('[data-prot]');
  var PROT=protEl?{id:protEl.getAttribute('data-variant'), p:parseFloat(protEl.getAttribute('data-precio'))||0, on:false}:null;
  // LIQUIDACIÓN (lp_config.liquidacion, snippet orv-lp-liquidacion): mua kèm SP xả kho, số lượng tuỳ ý, mặc định 0.
  // Giá xả do MÃ GIẢM TỰ ĐỘNG của Shopify áp ở giỏ/checkout (có SP trang trong giỏ) — ở đây chỉ cộng vào tổng + gửi kèm khi mua.
  var liqEl=document.querySelector('[data-liq]');
  var LIQ=liqEl?Array.prototype.map.call(liqEl.querySelectorAll('[data-liq-it]'),function(el){ return {el:el,id:el.getAttribute('data-variant'),p:parseFloat(el.getAttribute('data-precio'))||0,q:0}; }):null;
  if(LIQ&&!LIQ.length) LIQ=null;
  function liqTot(){ var s=0; if(LIQ) LIQ.forEach(function(x){ s+=x.p*x.q; }); return s; }
  function liqItems(){ return LIQ?LIQ.filter(function(x){ return x.q>0; }).map(function(x){ return {id:+x.id,quantity:x.q}; }):[]; }
  // giá SP thường (cent) theo variant SP GIÁ XẢ → gạch giá + tiết kiệm trong ngăn giỏ
  var LIQ_ANT={}; if(LIQ) LIQ.forEach(function(x){ LIQ_ANT[x.id]=Math.round((parseFloat(x.el.getAttribute('data-antes'))||0)*100); });
  function liqAntes(v){ return LIQ_ANT[String(v)]||0; }
  function liqRuta(){ return liqItems().map(function(o){ return ','+o.id+':'+o.quantity; }).join(''); }
  function render(){
    qty=Math.max(MINQ,Math.min(MAXQ,qty));
    var precio=precioDe(qty), tot=Math.round((precio+(PROT&&PROT.on?PROT.p:0)+liqTot())*100)/100;
    // combo: chọn/tô combo trùng số lượng, bỏ chọn phần còn lại
    packs.forEach(function(p){
      var on=(packDe(qty)===p.querySelector('input'));
      p.classList.toggle('sel',on);
      p.querySelector('input').checked=on;
    });
    // stepper trong box
    var un=document.getElementById('uds-n'); if(un) un.textContent=qty;
    if(masU) masU.classList.toggle('sel', masUnidad()? qty>3 : !packDe(qty));
    // số lượng + tên combo + giá trong 2 form
    document.querySelectorAll('.f-uds-n').forEach(function(el){el.textContent=qty});
    document.querySelectorAll('.pedido-tit').forEach(function(el){el.textContent=tituloDe(qty)});
    document.querySelectorAll('.pedido-pre').forEach(function(el){el.textContent=eur(precio)});
    document.querySelectorAll('[data-total]').forEach(function(el){el.textContent=eur(tot)});
    var cta=document.querySelector('[data-v="CTA_TEXTO"]');
    if(cta) cta.lastChild.textContent=(cta.getAttribute('data-label')||'')+' · '+eur(tot);
    if(RG) rgPintar(comboDe(qty));
    if(COL) colPintar(qty);
  }

  function setQty(v){ qty=v; render(); }
  function addQty(d){ qty=qty+d*PASO; render(); }

  // chọn combo -> nhảy số theo số lượng combo
  packs.forEach(function(p){
    p.querySelector('input').addEventListener('change',function(){
      setQty(parseInt(p.querySelector('input').getAttribute('data-uds'),10));
    });
  });
  // stepper trong box (1–100)
  if(masU) masU.querySelectorAll('.paso-btn').forEach(function(b){
    b.addEventListener('click',function(e){e.preventDefault(); addQty(parseInt(b.getAttribute('data-step'),10));});
  });
  // stepper trong mỗi form -> cùng một số lượng, đồng bộ tất cả
  document.querySelectorAll('[data-fstep]').forEach(function(b){
    b.addEventListener('click',function(e){e.preventDefault(); addQty(parseInt(b.getAttribute('data-fstep'),10));});
  });

  render();

  if(protEl){
    var protSet=function(on){
      PROT.on=on; protEl.classList.toggle('on',on); protEl.setAttribute('aria-checked',on?'true':'false'); render();
    };
    protEl.addEventListener('click',function(){ protSet(!PROT.on); });
    protEl.addEventListener('keydown',function(e){ if(e.key===' '||e.key==='Enter'||e.key==='Spacebar'){ e.preventDefault(); protSet(!PROT.on); } });
  }

  if(LIQ){
    var LIQ_BY={};
    var liqPintar=function(x){
      var on=x.q>0;
      x.el.classList.toggle('on',on);
      x.el.querySelector('[data-liq-add]').hidden=on;
      x.el.querySelector('.liq-step').hidden=!on;
      x.el.querySelector('[data-liq-n]').textContent=x.q;
    };
    var liqSet=function(x,q){ x.q=Math.max(0,Math.min(20,q)); liqPintar(x); render(); };
    var hojaAbierta=null, hojaFoco=null;
    var cerrarHoja=function(){
      if(!hojaAbierta) return;
      var h=hojaAbierta; hojaAbierta=null;
      h.classList.remove('abierto'); document.documentElement.classList.remove('cd-bloqueo');
      setTimeout(function(){ if(!h.classList.contains('abierto')) h.hidden=true; },280);
      if(hojaFoco&&hojaFoco.focus) hojaFoco.focus({preventScroll:true});
    };
    var abrirHoja=function(i,btn){
      var h=document.querySelector('[data-liq-hoja="'+i+'"]'); if(!h) return;
      hojaFoco=btn;
      h.querySelectorAll('img[data-src]').forEach(function(im){ im.src=im.getAttribute('data-src'); im.removeAttribute('data-src'); });
      var x=LIQ_BY[i], bt=h.querySelector('[data-liq-h-add]');
      if(bt&&x) bt.textContent=x.q>0?bt.getAttribute('data-ok'):bt.getAttribute('data-txt');
      h.hidden=false; h.offsetWidth; h.classList.add('abierto');
      document.documentElement.classList.add('cd-bloqueo');
      hojaAbierta=h;
      h.querySelector('.liq-h-panel').focus({preventScroll:true});
    };
    LIQ.forEach(function(x){
      var vb=x.el.querySelector('[data-liq-ver]');
      if(vb){ x.idx=vb.getAttribute('data-liq-ver'); LIQ_BY[x.idx]=x; vb.addEventListener('click',function(){ abrirHoja(x.idx,vb); }); }
      x.el.querySelector('[data-liq-add]').addEventListener('click',function(){ liqSet(x,1); var b=x.el.querySelector('[data-liq-d="1"]'); if(b) b.focus(); });
      x.el.querySelectorAll('[data-liq-d]').forEach(function(b){
        b.addEventListener('click',function(){ liqSet(x,x.q+parseInt(b.getAttribute('data-liq-d'),10)); if(!x.q) x.el.querySelector('[data-liq-add]').focus(); });
      });
    });
    document.querySelectorAll('[data-liq-hoja]').forEach(function(h){
      h.querySelectorAll('[data-liq-cerrar]').forEach(function(b){ b.addEventListener('click',cerrarHoja); });
      var big=h.querySelector('.liq-h-big');
      h.querySelectorAll('[data-liq-img]').forEach(function(b){
        b.addEventListener('click',function(){ if(big) big.src=b.getAttribute('data-liq-img'); h.querySelectorAll('[data-liq-img]').forEach(function(o){ o.classList.toggle('on',o===b); }); });
      });
      var add=h.querySelector('[data-liq-h-add]');
      if(add) add.addEventListener('click',function(){
        var x=LIQ_BY[h.getAttribute('data-liq-hoja')];
        if(x&&x.q<1) liqSet(x,1);
        cerrarHoja();
        if(x){ x.el.classList.add('liq-flash'); setTimeout(function(){ x.el.classList.remove('liq-flash'); },900); }
      });
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') cerrarHoja(); });
  }



  // ── ĐỒNG HỒ ĐẾM NGƯỢC: đếm tới 00:00 giờ Tây Ban Nha, tự quay vòng mỗi ngày ──
  // Mọi khách thấy CÙNG một số. Không lưu localStorage, không reset khi tải lại trang.
  (function(){
    var visor=document.querySelector('.pdp-media .visor'); if(!visor) return;
    var slides=visor.querySelectorAll('.gslide');
    var thumbs=document.querySelectorAll('.pdp-media .miniatura .mini-btn');
    var vids=visor.querySelectorAll('video');
    var idx=Array.prototype.indexOf.call(slides, visor.querySelector('.gslide.on')); if(idx<0) idx=0;
    // chỉ video của slide đang hiện mới được tải + chạy. Slide ĐẦU là video (vd Desplumadora, Plumero): ảnh bìa (poster, đã preload)
    // là ảnh LCP → chỉ tải file video SAU window load + lúc rảnh (trasCarga), không tranh băng thông với ảnh LCP / CSS (perf 03/10/2026).
    vids.forEach(function(v){ if(!(slides[idx]&&slides[idx].contains(v))) v.pause(); });
    // 23/10/2026: video slide đầu chỉ tải + chạy sau THAO TÁC ĐẦU TIÊN của khách (chạm, cuộn, phím, chuột) — không tự tải sau window
    // load nữa. Lý do: khung hình đầu của video được tính là LCP mới (PageSpeed mobile: LCP = video, 4,8 s vì phải tải ~1,2 MB mp4);
    // sau thao tác đầu tiên trình duyệt ngừng đo LCP → LCP = ảnh bìa (đã preload). Trước khi chạm: hiện ảnh bìa, giống hệt trước.
    var EV=['pointerdown','touchstart','keydown','wheel','scroll'], vidIni=false;
    function iniVid(){
      if(vidIni) return; vidIni=true;
      EV.forEach(function(t){ window.removeEventListener(t,iniVid,true); });
      trasCarga(function(){ vids.forEach(function(v){ if(slides[idx]&&slides[idx].contains(v)) playVid(v); }); });
    }
    EV.forEach(function(t){ window.addEventListener(t,iniVid,{capture:true,passive:true}); });
    // ảnh slide 2+ chưa có src: nạp slide kế tiếp sau window load; khi chuyển → nạp slide đích + slide sau nó
    function sig(k){ return slides[(k+1)%slides.length]; }
    trasCarga(function(){ cargarImg(sig(idx)); });
    // thumbnail (data-src, xem sections/orv-lp.liquid): nạp sau window load — không tranh băng thông với ảnh hero (LCP)
    trasCarga(function(){ thumbs.forEach(function(t){ cargarImg(t.querySelector('img[data-src]')); }); });
    function show(n){
      n=(n%slides.length+slides.length)%slides.length;
      cargarImg(slides[n]); cargarImg(sig(n));
      slides[idx].classList.remove('on'); if(thumbs[idx]){thumbs[idx].classList.remove('on');thumbs[idx].removeAttribute('aria-current');}
      vids.forEach(function(v){v.pause();});
      idx=n;
      slides[idx].classList.add('on'); if(thumbs[idx]){thumbs[idx].classList.add('on');thumbs[idx].setAttribute('aria-current','true');}
      vids.forEach(function(v){ if(slides[idx].contains(v)){ try{v.currentTime=0;}catch(e){} playVid(v); } else v.pause(); });
    }
    var izq=visor.querySelector('.gflecha.izq'), der=visor.querySelector('.gflecha.der');
    if(izq) izq.addEventListener('click',function(){show(idx-1);});
    if(der) der.addEventListener('click',function(){show(idx+1);});
    thumbs.forEach(function(t,i){ t.addEventListener('click',function(){show(i);}); });
    // swipe en móvil
    var x0=null;
    visor.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    visor.addEventListener('touchend',function(e){ if(x0===null)return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) show(idx+(dx<0?1:-1)); x0=null; },{passive:true});
  })();


  // ── 3 bước: kéo bằng chuột, nút mũi tên, chấm chỉ báo ──
  (function(){
    var car=document.getElementById('pasos'), pistas=document.getElementById('pistas-pasos');
    if(!car||!pistas) return;
    var puntos=pistas.querySelectorAll('i'), tarjetas=[].slice.call(car.querySelectorAll('.paso'));
    var izq=document.getElementById('paso-izq'), der=document.getElementById('paso-der');

    function actual(){
      var centro=car.scrollLeft+car.clientWidth/2, mejor=0, min=Infinity;
      tarjetas.forEach(function(t,k){
        var d=Math.abs(t.offsetLeft+t.offsetWidth/2-centro);
        if(d<min){min=d;mejor=k;}
      });
      return mejor;
    }
    function pintar(){
      var k=actual();
      puntos.forEach(function(pt,i){pt.classList.toggle('on',i===k)});
      if(izq) izq.disabled = car.scrollLeft<=4;
      if(der) der.disabled = car.scrollLeft >= car.scrollWidth-car.clientWidth-4;
    }
    function irA(k){
      k=Math.max(0,Math.min(tarjetas.length-1,k));
      var t=tarjetas[k];
      car.scrollTo({left:t.offsetLeft+t.offsetWidth/2-car.clientWidth/2, behavior:'smooth'});
    }
    car.addEventListener('scroll',function(){window.requestAnimationFrame(pintar)},{passive:true});
    if(izq) izq.addEventListener('click',function(){irA(actual()-1)});
    if(der) der.addEventListener('click',function(){irA(actual()+1)});
    puntos.forEach(function(pt,k){pt.addEventListener('click',function(){irA(k)})});

    // kéo bằng chuột (trackpad/desktop không vuốt ngang được)
    var bajo=false, x0=0, s0=0, movido=0;
    car.addEventListener('mousedown',function(e){
      bajo=true; movido=0; x0=e.pageX; s0=car.scrollLeft;
      car.classList.add('arrastrando');
    });
    window.addEventListener('mousemove',function(e){
      if(!bajo) return;
      var d=e.pageX-x0; movido=Math.abs(d);
      car.scrollLeft=s0-d;
      if(movido>3) e.preventDefault();
    });
    window.addEventListener('mouseup',function(){
      if(!bajo) return;
      bajo=false; car.classList.remove('arrastrando');
      if(movido>20) irA(actual());   // thả ra thì căn vào thẻ gần nhất
      else pintar();
    });
    car.addEventListener('dragstart',function(e){e.preventDefault()});

    // bàn phím
    car.setAttribute('tabindex','0');
    car.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();irA(actual()+1)}
      if(e.key==='ArrowLeft'){e.preventDefault();irA(actual()-1)}
    });

    pintar();
  })();


  // ── Reseñas: hiện 6, bấm để mở 3 cái còn lại ──
  (function(){
    var btn=document.getElementById('btn-resenas');
    if(!btn) return;
    var extras=document.querySelectorAll('.resena.extra');
    var txt=btn.querySelector('.vm-txt');
    btn.addEventListener('click',function(){
      var abierto=btn.getAttribute('aria-expanded')==='true';
      extras.forEach(function(e){e.hidden=abierto});
      btn.setAttribute('aria-expanded', abierto?'false':'true');
      var OL=window.ORV_L||{}; txt.textContent = abierto ? (OL.mas_rv||'Ver más reseñas') : (OL.menos_rv||'Ver menos reseñas');
      if(abierto) btn.scrollIntoView({block:'center',behavior:'smooth'});
    });
  })();


  // ── Carousel vấn đề (3 thẻ, có điểm đầu/cuối) ──
  (function(){
    var car=document.getElementById('carr-prob'), pistas=document.getElementById('pistas-prob');
    if(!car||!pistas) return;
    var puntos=pistas.querySelectorAll('i'), tarjetas=[].slice.call(car.querySelectorAll('.tarj-p'));
    var izq=document.getElementById('prob-izq'), der=document.getElementById('prob-der');
    function actual(){
      var c=car.scrollLeft+car.clientWidth/2, mejor=0, min=Infinity;
      tarjetas.forEach(function(t,k){var d=Math.abs(t.offsetLeft+t.offsetWidth/2-c);if(d<min){min=d;mejor=k;}});
      return mejor;
    }
    function pintar(){
      var k=actual();
      puntos.forEach(function(pt,i){pt.classList.toggle('on',i===k)});
      if(izq) izq.disabled=car.scrollLeft<=4;
      if(der) der.disabled=car.scrollLeft>=car.scrollWidth-car.clientWidth-4;
    }
    function irA(k){
      k=Math.max(0,Math.min(tarjetas.length-1,k));
      var t=tarjetas[k];
      car.scrollTo({left:t.offsetLeft+t.offsetWidth/2-car.clientWidth/2,behavior:'smooth'});
    }
    car.addEventListener('scroll',function(){window.requestAnimationFrame(pintar)},{passive:true});
    if(izq) izq.addEventListener('click',function(){irA(actual()-1)});
    if(der) der.addEventListener('click',function(){irA(actual()+1)});
    puntos.forEach(function(pt,k){pt.addEventListener('click',function(){irA(k)})});
    var bajo=false,x0=0,s0=0,mov=0;
    car.addEventListener('mousedown',function(e){bajo=true;mov=0;x0=e.pageX;s0=car.scrollLeft;car.classList.add('arrastrando')});
    window.addEventListener('mousemove',function(e){if(!bajo)return;var d=e.pageX-x0;mov=Math.abs(d);car.scrollLeft=s0-d;if(mov>3)e.preventDefault()});
    window.addEventListener('mouseup',function(){if(!bajo)return;bajo=false;car.classList.remove('arrastrando');if(mov>20)irA(actual());else pintar()});
    car.addEventListener('dragstart',function(e){e.preventDefault()});
    car.setAttribute('tabindex','0');
    car.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();irA(actual()+1)}
      if(e.key==='ArrowLeft'){e.preventDefault();irA(actual()-1)}});
    pintar();
  })();

  // ── Carousel "Más clientes contentos" — vòng lặp vô hạn ──
  (function(){
    var car=document.getElementById('carr-rv'), pistas=document.getElementById('pistas-rv');
    if(!car||!pistas) return;
    var puntos=pistas.querySelectorAll('i');
    var originales=[].slice.call(car.querySelectorAll('.tarj-rv'));
    var N=originales.length;
    if(!N) return;

    // nhân 3 bộ thẻ: [clon trước][gốc][clon sau] -> cuộn tới đâu cũng còn thẻ
    var antes=document.createDocumentFragment(), despues=document.createDocumentFragment();
    originales.forEach(function(t){
      var a=t.cloneNode(true); a.setAttribute('aria-hidden','true'); a.classList.add('clon'); antes.appendChild(a);
      var b=t.cloneNode(true); b.setAttribute('aria-hidden','true'); b.classList.add('clon'); despues.appendChild(b);
    });
    car.insertBefore(antes, car.firstChild);
    car.appendChild(despues);

    var todas=[].slice.call(car.querySelectorAll('.tarj-rv'));
    var izq=document.getElementById('rv-izq'), der=document.getElementById('rv-der');
    var animando=false;

    function centroDe(t){ return t.offsetLeft + t.offsetWidth/2 - car.clientWidth/2; }
    function indiceActual(){
      var c=car.scrollLeft+car.clientWidth/2, mejor=0, min=Infinity;
      todas.forEach(function(t,k){var d=Math.abs(t.offsetLeft+t.offsetWidth/2-c); if(d<min){min=d;mejor=k;}});
      return mejor;
    }
    // đưa về bộ giữa mà không giật
    function recentrar(){
      var k=indiceActual();
      if(k<N){                    // đang ở bộ clon trước -> nhảy tới bộ giữa
        car.style.scrollBehavior='auto';
        car.scrollLeft=centroDe(todas[k+N]);
        car.style.scrollBehavior='';
      } else if(k>=2*N){          // đang ở bộ clon sau -> lùi về bộ giữa
        car.style.scrollBehavior='auto';
        car.scrollLeft=centroDe(todas[k-N]);
        car.style.scrollBehavior='';
      }
    }
    function pintar(){
      var k=indiceActual()%N;
      puntos.forEach(function(pt,i){pt.classList.toggle('on',i===k)});
    }
    function mover(paso){
      if(animando) return;
      animando=true;
      var destino=todas[indiceActual()+paso];
      if(!destino){ animando=false; return; }
      car.scrollTo({left:centroDe(destino), behavior:'smooth'});
      setTimeout(function(){ recentrar(); pintar(); animando=false; }, 420);
    }
    function irAPunto(k){
      if(animando) return;
      animando=true;
      var base=Math.floor(indiceActual()/N)*N;   // giữ nguyên bộ đang đứng
      car.scrollTo({left:centroDe(todas[base+k]), behavior:'smooth'});
      setTimeout(function(){ recentrar(); pintar(); animando=false; }, 420);
    }

    var t0=null;
    car.addEventListener('scroll',function(){
      window.requestAnimationFrame(pintar);
      clearTimeout(t0);
      t0=setTimeout(function(){ if(!animando) recentrar(); }, 140);   // vuốt tay xong thì tự căn lại
    },{passive:true});

    if(izq) izq.addEventListener('click',function(){mover(-1)});
    if(der) der.addEventListener('click',function(){mover(1)});
    puntos.forEach(function(pt,k){pt.addEventListener('click',function(){irAPunto(k)})});

    var bajo=false,x0=0,s0=0,movido=0;
    car.addEventListener('mousedown',function(e){bajo=true;movido=0;x0=e.pageX;s0=car.scrollLeft;car.classList.add('arrastrando')});
    window.addEventListener('mousemove',function(e){if(!bajo)return;var d=e.pageX-x0;movido=Math.abs(d);car.scrollLeft=s0-d;if(movido>3)e.preventDefault()});
    window.addEventListener('mouseup',function(){
      if(!bajo)return; bajo=false; car.classList.remove('arrastrando');
      if(movido>20){ animando=true;
        car.scrollTo({left:centroDe(todas[indiceActual()]), behavior:'smooth'});
        setTimeout(function(){recentrar();pintar();animando=false;},420);
      } else pintar();
    });
    car.addEventListener('dragstart',function(e){e.preventDefault()});

    car.setAttribute('tabindex','0');
    car.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();mover(1)}
      if(e.key==='ArrowLeft'){e.preventDefault();mover(-1)}});

    // khởi động: đứng ở thẻ đầu của bộ giữa
    car.style.scrollBehavior='auto';
    car.scrollLeft=centroDe(todas[N]);
    car.style.scrollBehavior='';
    pintar();
  })();

  // ── CHECKOUT SHOPIFY (COD) · thay popup form + Google Sheet ──
  // 1 cái -> biến thể "1 cepillo" x1 · 2 cái -> "1 + 1 GRATIS" x1 · 3+ cái -> "Unidad (3+)" x số lượng
  // Gói N (data-uds=N) = variant riêng, số lượng 1 · N không có gói riêng = variant "3+" (data-variant ở .mas-uds) × N
  function abrir(e){
    if(e&&e.preventDefault) e.preventDefault();
    var q=qty, c=comboDe(q);
    if(!c.length||c.some(function(x){ return !x.id; })) return;
    try{ if(window.fbq) fbq('track','InitiateCheckout',{value:precioDe(q),currency:'EUR',num_items:q,content_name:tituloDe(q)}); }catch(err){}
    var qs=window.location.search?('?'+window.location.search.slice(1)):'';
    var ruta=c.map(function(x){ return x.id+':'+x.n; }).join(',');
    ruta+=liqRuta();   // món xả kho (LIQUIDACIÓN) — sau SP trang (properties quà chỉ áp dòng đầu)
    if(PROT&&PROT.on) ruta+=','+PROT.id+':1';   // bảo vệ: luôn SL 1, dòng CUỐI (properties quà của permalink chỉ áp dòng đầu)
    var rep=COL?colReparto(c,colSel(q)):[];
    var pr=(RG||COL)?c.map(function(x,i){ return propsDe(x.id,rep[i]); }):[];
    if(pr.some(function(p){ return p; })){
      // Có quà: permalink chỉ nhận properties cho DÒNG ĐẦU (Base64 URL-encoded JSON) → 1 dòng: permalink + properties;
      // nhiều dòng (ghép gói): thay giỏ = /cart/clear.js + /cart/add.js (mỗi dòng 1 property) rồi vào /checkout (giữ UTM).
      if(c.length===1){
        var b64=btoa(unescape(encodeURIComponent(JSON.stringify(pr[0])))).replace(/\+/g,'-').replace(/\//g,'_');
        setTimeout(function(){ window.location.href=raiz+'cart/'+ruta+(qs?qs+'&':'?')+'properties='+encodeURIComponent(b64); },150);
        return;
      }
      pedirJSON('cart/clear.js',{})
        .then(function(){ return pedirJSON('cart/add.js',{items:c.map(function(x,i){ var o={id:+x.id,quantity:x.n}; if(pr[i]) o.properties=pr[i]; return o; }).concat(liqItems()).concat(PROT&&PROT.on?[{id:+PROT.id,quantity:1}]:[])}); })
        .then(function(){ window.location.href=raiz+'checkout'+qs; })
        .catch(function(){ window.location.href=raiz+'cart/'+ruta+qs; });
      return;
    }
    setTimeout(function(){ window.location.href=raiz+'cart/'+ruta+qs; },150);
  }
  document.querySelectorAll('[data-abrir]').forEach(function(el){el.addEventListener('click',abrir)});

  // ── GIỎ HÀNG (giỏ Shopify dùng chung với trang chủ) ──
  // Icon giỏ + sau khi thêm → mở NGĂN GIỎ trượt từ phải (#orv-cd), vẽ từ /cart.js; tăng/giảm/xoá → /cart/change.js
  var raiz=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var atc=document.querySelector('[data-orv-atc]');
  var cd=document.getElementById('orv-cd');
  function pintarGiro(n){
    document.querySelectorAll('[data-orv-cart-count]').forEach(function(b){ b.textContent=n; b.hidden=!(n>0); });
  }
  function pedirJSON(url,body){
    var o={headers:{'Accept':'application/json'}};
    if(body){ o.method='POST'; o.headers['Content-Type']='application/json'; o.body=JSON.stringify(body); }
    return fetch(raiz+url,o).then(function(res){ if(!res.ok) throw res; return res.json(); });
  }
  function dinero(c){
    var f=(cd&&cd.getAttribute('data-money'))||'{{amount_with_comma_separator}} €';
    function fmt(dec,miles,sep){
      var v=(c/100).toFixed(dec).split('.');
      v[0]=v[0].replace(/\B(?=(\d{3})+(?!\d))/g,miles);
      return v[1]?v[0]+sep+v[1]:v[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      if(k==='amount') return fmt(2,',','.');
      if(k==='amount_no_decimals') return fmt(0,',','.');
      if(k==='amount_with_comma_separator') return fmt(2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator') return fmt(0,'.',',');
      if(k==='amount_with_apostrophe_separator') return fmt(2,"'",'.');
      return fmt(2,'.',',');
    });
  }
  function esc(t){ return String(t==null?'':t).replace(/[&<>"]/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  // ── GIỎ = GIÁ NGOÀI TRANG: SP của trang này trong giỏ luôn được xếp lại theo gói rẻ nhất (comboDe, giống ô số lượng) ──
  // Mỗi variant của trang → số món (gói: max(data-uds, data-tambien); variant đơn giá: 1). Variant không thuộc trang → giữ nguyên.
  var ULT=null;
  function udsMapa(){
    var m={};
    document.querySelectorAll('.packs input').forEach(function(el){
      var u=parseInt(el.getAttribute('data-uds'),10)||0;
      (el.getAttribute('data-tambien')||'').split(',').forEach(function(t){ t=parseInt(t,10); if(t>u) u=t; });
      if(u) m[el.getAttribute('data-variant')]=u;
    });
    var mu=masUnidad(); if(mu&&!m[mu.getAttribute('data-variant')]) m[mu.getAttribute('data-variant')]=1;
    return m;
  }
  function unidadesDe(cart){ var M=udsMapa(), U=0; (cart.items||[]).forEach(function(it){ var u=M[String(it.variant_id)]; if(u) U+=u*it.quantity; }); return U; }
  function itemDe(x,txt){ var o={id:+x.id,quantity:x.n}, p=propsDe(x.id,txt); if(p) o.properties=p; return o; }
  // COL: màu từng món của các dòng SP trang này trong giỏ, theo thứ tự giỏ → [{it, cols:[…]}]
  function colDeGiro(cart){
    var M=udsMapa(), r=[];
    (cart.items||[]).forEach(function(it){ var u=M[String(it.variant_id)]; if(u) r.push({it:it, cols:colLista(colorDe(it),u*it.quantity)}); });
    return r;
  }
  // Đặt tổng số món của SP trang này = total (0 = bỏ hết): xoá các dòng cũ của SP, thêm tổ hợp rẻ nhất. Trả về cart mới;
  // null = không ghép được (total lệch bước gói) → nơi gọi dùng cách cũ.
  // cols (khi có COL) = màu của TỪNG món sau khi đổi (dài = total) → chia lại cho các dòng mới (colReparto).
  function fijarUnidades(cart,total,extra,cols){
    var M=udsMapa(), upd={}, hay=false;
    (cart.items||[]).forEach(function(it){ if(M[String(it.variant_id)]){ upd[it.key]=0; hay=true; } });
    var c=total>0?comboDe(total):[];
    if(total>0&&(!c.length||c.some(function(x){ return !x.id; }))) return null;
    var rep=(COL&&cols)?colReparto(c,cols):[];
    return (hay?pedirJSON('cart/update.js',{updates:upd}):Promise.resolve())
      .then(function(){ var its=c.map(function(x,i){ return itemDe(x,rep[i]); }).concat(total>0&&extra?extra:[]); return its.length?pedirJSON('cart/add.js',{items:its}):null; })
      .then(function(){ return pedirJSON('cart.js'); });
  }
  // Dòng "Protección de envío" trong giỏ: nhận theo variant của trang hoặc handle SP bảo vệ (#orv-cd data-prot-handle).
  // Luôn SL 1; giỏ không còn hàng nào khác → tự xoá. Vẽ bằng logo khiên, không có −/+, chỉ nút xoá.
  var PROT_H=(cd&&cd.getAttribute('data-prot-handle'))||'proteccion-envio-orvenisa';
  function esProt(it){ return (PROT&&String(it.variant_id)===String(PROT.id))||it.handle===PROT_H; }
  function normProt(cart){
    var its=cart.items||[], k=-1, otros=0;
    its.forEach(function(it,i){ if(esProt(it)){ if(k<0) k=i; } else otros++; });
    if(k<0) return null;
    if(!otros) return pedirJSON('cart/change.js',{line:k+1,quantity:0});
    if(its[k].quantity>1) return pedirJSON('cart/change.js',{line:k+1,quantity:1});
    return null;
  }
  // Ô bảo vệ TRONG NGĂN GIỎ (bản sao ô trên trang, ngay dưới món cuối của danh sách): tích = thêm SP bảo vệ SL 1, bỏ tích = xoá dòng đó.
  // Trạng thái theo giỏ thật; bấm ở đây cũng đổi ô trên trang (để "Añadir"/mua ngay sau đó khớp). Có ô này → không vẽ dòng .cd-prot.
  var cdProt=null;
  if(cd&&protEl){
    cdProt=protEl.cloneNode(true);
    cdProt.removeAttribute('data-prot'); cdProt.classList.remove('on'); cdProt.classList.add('cd-prot-of');
    var gr=cdProt.querySelector('linearGradient[id]');
    if(gr){ var gid=gr.id; cdProt.innerHTML=cdProt.innerHTML.split(gid).join(gid+'-cd'); }
    var cdProtLi=document.createElement('li'); cdProtLi.className='cd-prot-li'; cdProtLi.appendChild(cdProt);
    var cdProtTog=function(){
      if(!ULT||cdProt.classList.contains('cargando')) return;
      var k=-1; (ULT.items||[]).forEach(function(it,i){ if(k<0&&esProt(it)) k=i; });
      cdProt.classList.add('cargando');
      (k<0?pedirJSON('cart/add.js',{items:[{id:+PROT.id,quantity:1}]}).then(function(){ return pedirJSON('cart.js'); })
          :pedirJSON('cart/change.js',{line:k+1,quantity:0}))
        .then(function(cart){ if(protSet) protSet(k<0); pintarCarrito(cart); })
        .catch(function(){})
        .then(function(){ cdProt.classList.remove('cargando'); });
    };
    cdProt.addEventListener('click',cdProtTog);
    cdProt.addEventListener('keydown',function(e){ if(e.key===' '||e.key==='Enter'||e.key==='Spacebar'){ e.preventDefault(); cdProtTog(); } });
  }
  function logoProt(i){
    var g='orvShieldG-cd'+i;
    return '<svg viewBox="0 0 48 48" width="48" height="48" aria-hidden="true"><defs><linearGradient id="'+g+'" x1="10" y1="4" x2="38" y2="44" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#16A58C"/><stop offset="1" stop-color="#0A6656"/></linearGradient></defs><path d="M24 3 41 9.5V22c0 11-7.5 19.5-17 23C14.5 41.5 7 33 7 22V9.5Z" fill="url(#'+g+')"/><path d="M24 3 7 9.5V22c0 11 7.5 19.5 17 23Z" fill="#FFFFFF" fill-opacity=".1"/><path d="M24 5.2 39 11v11c0 9.9-6.6 17.6-15 20.9C15.6 39.6 9 31.9 9 22V11Z" fill="none" stroke="#FFFFFF" stroke-opacity=".28" stroke-width="1"/><path d="M24 13.5 32.5 17.8 24 22.1 15.5 17.8Z" fill="#FFFFFF"/><path d="M15.5 17.8V27.6L24 31.9V22.1Z" fill="#FFFFFF" fill-opacity=".86"/><path d="M32.5 17.8V27.6L24 31.9V22.1Z" fill="#FFFFFF" fill-opacity=".68"/><path d="M19.8 15.6 28.2 19.9" stroke="#0C7A69" stroke-width="1.6" stroke-linecap="round"/><circle cx="34.5" cy="34.5" r="7.6" fill="#B84E22" stroke="#FFFFFF" stroke-width="2"/><path d="M31.2 34.7 33.5 37 37.8 32.4" fill="none" stroke="#FFFFFF" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function pintarCarrito(cart){
    var fix=normProt(cart);
    if(fix){ fix.then(pintarCarrito).catch(function(){}); return; }
    // giá xả chỉ khi có SP trang (snippet orv-liq-guard): thiếu → đổi món xả về SP thường (_liq), có lại → đổi về SP giá xả
    var lfix=window.orvLiqFix?window.orvLiqFix(cart):null;
    if(lfix){ lfix.then(pintarCarrito).catch(function(){}); return; }
    ULT=cart;
    pintarGiro(cart.item_count);
    if(!cd) return;
    var vacio=!cart.item_count;
    cd.querySelector('[data-cd-vacio]').hidden=!vacio;
    cd.querySelector('[data-cd-pie]').hidden=vacio;
    cd.querySelector('[data-cd-items]').hidden=vacio;
    cd.querySelector('[data-cd-tit]').hidden=vacio;
    var n=cd.querySelector('[data-cd-n]'); n.textContent=cart.item_count;
    cd.querySelector('[data-cd-total]').textContent=dinero(cart.total_price);
    var tq=cd.getAttribute('data-t-quitar'), tm=cd.getAttribute('data-t-menos'), tM=cd.getAttribute('data-t-mas');
    // dòng bảo vệ luôn vẽ CUỐI danh sách (data-linea vẫn là vị trí thật trong giỏ cho /cart/change.js)
    if(cdProt){ var tp=(cart.items||[]).some(esProt); cdProt.classList.toggle('on',tp); cdProt.setAttribute('aria-checked',tp?'true':'false'); }
    var liqAh=0;
    // THỨ TỰ HIỂN THỊ (Shopify đưa món thêm sau lên đầu): SP của trang → SP khác → món xả kho (giá xả / _liq) → bảo vệ.
    // Chỉ đổi thứ tự vẽ; data-linea vẫn = vị trí thật trong giỏ.
    var UM=udsMapa();
    function rango(it){ if(esProt(it)) return 3; if(UM[String(it.variant_id)]) return 0; if(liqAntes(it.variant_id)||(it.properties&&it.properties._liq)) return 2; return 1; }
    var orden=(cart.items||[]).map(function(it,i){ return {it:it,i:i,r:rango(it)}; });
    orden.sort(function(a,b){ return (a.r-b.r)||(a.i-b.i); });
    cd.querySelector('[data-cd-items]').innerHTML=orden.map(function(o){
      var it=o.it, i=o.i;
      if(esProt(it)&&cdProt) return '';
      if(esProt(it)) return '<li class="cd-it cd-prot" data-linea="'+(i+1)+'">'+
        '<span class="cd-img cd-prot-img">'+logoProt(i)+'</span>'+
        '<div class="cd-info"><span class="cd-nom">'+esc(it.product_title)+'</span>'+
        '<div class="cd-fila"><button type="button" class="cd-quitar" data-cd-q="0" aria-label="'+esc(tq)+' '+esc(it.product_title)+'"><svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5"/></svg></button></div></div>'+
        '<div class="cd-precio"><b>'+dinero(it.final_line_price)+'</b></div>'+
      '</li>';
      var img=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=180':'';
      var va=(it.variant_title&&!it.product_has_only_default_variant)?'<small>'+esc(it.variant_title)+'</small>':'';
      // màu (lp_config.colores → property, vd "Color: Luz cálida") dưới tên variant
      if(COL&&colorDe(it)) va+='<small class="cd-co">'+esc(COL.prop)+': '+esc(colorDe(it))+'</small>';
      // giảm giá Shopify trên dòng (vd "Liquidación con motosierra") → nhãn + số tiền giảm
      var dTot=0, dTit='';
      (it.line_level_discount_allocations||[]).forEach(function(d){ dTot+=d.amount||0; if(!dTit&&d.discount_application) dTit=d.discount_application.title||''; });
      if(dTot>0) va+='<small class="cd-liq">'+(dTit?esc(dTit)+' · ':'')+'−'+dinero(dTot)+'</small>';
      var tachado=it.original_line_price>it.final_line_price?'<s>'+dinero(it.original_line_price)+'</s>':'';
      // SP GIÁ XẢ (ô Liquidación): gạch giá SP thường × SL + nhãn tiết kiệm
      var la=liqAntes(it.variant_id);
      if(la>it.final_price){ var lah=la*it.quantity; tachado='<s>'+dinero(lah)+'</s>'; liqAh+=lah-it.final_line_price; va+='<small class="cd-liq">'+esc(liqEl.getAttribute('data-tag')||'')+' · −'+dinero(lah-it.final_line_price)+'</small>'; }
      // DÒNG QUÀ RIÊNG dưới SP (line item property "Regalo" do khối REGALO gửi) — đi theo dòng SP khi đổi số lượng / xoá
      var pp=it.properties||{}, rgv=parseInt(pp._regalo_valor,10)||0;
      var rg=pp.Regalo?'<div class="cd-rg">'+
        '<span class="cd-rg-img">'+(pp._regalo_img?'<img src="'+esc(pp._regalo_img)+'" alt="" width="44" height="44" loading="lazy">':'<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8.5h14V12M12 8v12.5"/><path d="M12 8c-1.6-3.6-6-4-6-1.5C6 8 9 8 12 8zM12 8c1.6-3.6 6-4 6-1.5C18 8 15 8 12 8z"/></svg>')+'</span>'+
        '<span class="cd-rg-tx"><b>🎁 '+esc(pp.Regalo.indexOf(' + ')>-1?(it.quantity>1?it.quantity+' × ':'')+pp.Regalo:rgSuma([{t:pp.Regalo,n:it.quantity}]))+'</b><small>'+esc(cd.getAttribute('data-t-regalo')||'Regalo incluido')+'</small></span>'+
        '<span class="cd-rg-pr"><b>'+esc(RG?RG.badge:'GRATIS')+'</b>'+(rgv?'<s>'+dinero(rgv*it.quantity)+'</s>':'')+'</span>'+
      '</div>':'';
      return '<li class="cd-it" data-linea="'+(i+1)+'">'+
        '<a class="cd-img" href="'+esc(it.url)+'">'+(img?'<img src="'+esc(img)+'" alt="'+esc(it.product_title)+'" width="90" height="90" loading="lazy">':'')+'</a>'+
        '<div class="cd-info"><a class="cd-nom" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+va+
        '<div class="cd-fila"><div class="cd-cant">'+
          '<button type="button" data-cd-q="'+(it.quantity-1)+'" aria-label="'+esc(tm)+'">&minus;</button>'+
          '<span>'+it.quantity+'</span>'+
          '<button type="button" data-cd-q="'+(it.quantity+1)+'" aria-label="'+esc(tM)+'">+</button></div>'+
          '<button type="button" class="cd-quitar" data-cd-q="0" aria-label="'+esc(tq)+' '+esc(it.product_title)+'"><svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5"/></svg></button>'+
        '</div></div>'+
        '<div class="cd-precio">'+tachado+'<b>'+dinero(it.final_line_price)+'</b></div>'+rg+
      '</li>';
    }).join('');
    if(cdProt) cd.querySelector('[data-cd-items]').appendChild(cdProtLi);   // ô bảo vệ ngay dưới món cuối
    // tổng tiết kiệm (mọi giảm giá Shopify trong giỏ)
    var ah=cd.querySelector('[data-cd-ahorro]');
    if(ah){
      var td=(cart.total_discount||0)+liqAh; ah.hidden=!(td>0);
      ah.querySelector('[data-cd-ahorro-t]').textContent=(liqEl&&liqEl.getAttribute('data-ahorro'))||'Ahorras';
      ah.querySelector('[data-cd-ahorro-v]').textContent='−'+dinero(td);
    }
    // LIQUIDACIÓN: giỏ có món xả nhưng KHÔNG có SP trang → nhắc + nút thêm lại SP trang (giá xả chỉ áp khi có SP này)
    if(LIQ){
      // món xả đã bị đổi về giá thường (property _liq do orv-liq-guard gắn)
      var hayLiq=(cart.items||[]).some(function(it){ return it.properties&&it.properties._liq; });
      if(hayLiq&&unidadesDe(cart)===0){
        var av=document.createElement('li'); av.className='cd-liq-aviso';
        av.innerHTML='<span>'+esc(liqEl.getAttribute('data-aviso'))+'</span><button type="button" class="cd-liq-moto" data-cd-liq-moto>'+esc(liqEl.getAttribute('data-aviso-btn'))+' · '+esc(eur(precioDe(MINQ)))+'</button>';
        var ul=cd.querySelector('[data-cd-items]'); ul.insertBefore(av,ul.firstChild);
      }
    }
  }
  var foco=null;
  function abrirCarrito(){
    if(!cd) return false;
    foco=document.activeElement;
    cd.hidden=false; cd.offsetWidth; cd.classList.add('abierto');
    document.documentElement.classList.add('cd-bloqueo');
    cd.querySelector('.cd-panel').focus({preventScroll:true});
    return true;
  }
  function cerrarCarrito(){
    if(!cd||cd.hidden) return;
    cd.classList.remove('abierto');
    document.documentElement.classList.remove('cd-bloqueo');
    setTimeout(function(){ if(!cd.classList.contains('abierto')) cd.hidden=true; },300);
    if(foco&&foco.focus) foco.focus({preventScroll:true});
  }
  if(cd){
    cd.querySelectorAll('[data-cd-cerrar]').forEach(function(b){ b.addEventListener('click',cerrarCarrito); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') cerrarCarrito(); });
    cd.querySelector('[data-cd-items]').addEventListener('click',function(e){
      var bm=e.target.closest('[data-cd-liq-moto]');
      if(bm){
        bm.disabled=true;
        pedirJSON('cart/add.js',{items:comboDe(MINQ).map(function(x){ return itemDe(x); })})
          .then(function(){ return pedirJSON('cart.js'); }).then(pintarCarrito)
          .catch(function(){ bm.disabled=false; });
        return;
      }
      var b=e.target.closest('[data-cd-q]'); if(!b) return;
      var li=b.closest('[data-linea]'); li.classList.add('cargando');
      var nq=+b.getAttribute('data-cd-q'), it=ULT&&ULT.items[+li.getAttribute('data-linea')-1];
      var u=it&&udsMapa()[String(it.variant_id)], pr=null;
      if(u){
        // SP của trang: +/− = thêm/bớt 1 bước (PASO) trên TỔNG số món, xoá = bỏ số món của dòng đó → xếp lại gói rẻ nhất
        var U=unidadesDe(ULT), tot=b.classList.contains('cd-quitar')?U-u*it.quantity:U+(nq>it.quantity?PASO:-PASO);
        var cols=null;
        if(COL){
          // màu từng món: xoá dòng → bỏ màu của dòng đó · − → bỏ PASO món cuối của dòng · + → thêm PASO món cùng màu cuối của dòng
          cols=[];
          colDeGiro(ULT).forEach(function(o){
            var a=o.cols;
            if(o.it.key===it.key){
              if(b.classList.contains('cd-quitar')) a=[];
              else if(nq>it.quantity){ a=a.slice(); for(var j=0;j<PASO;j++) a.push(a[a.length-1]||COL.def); }
              else a=a.slice(0,Math.max(0,a.length-PASO));
            }
            cols=cols.concat(a);
          });
          tot=cols.length;
        }
        pr=fijarUnidades(ULT,Math.max(0,tot),null,cols);
      }
      (pr||pedirJSON('cart/change.js',{line:+li.getAttribute('data-linea'),quantity:nq}))
        .then(pintarCarrito)
        .catch(function(){ li.classList.remove('cargando'); });
    });
    document.querySelectorAll('.cabecera .carrito').forEach(function(a){
      a.addEventListener('click',function(e){
        e.preventDefault(); abrirCarrito();
        pedirJSON('cart.js').then(pintarCarrito).catch(function(){ window.location.href=a.href; });
      });
    });
  }
  if(atc) atc.addEventListener('click',function(){
    var q=qty, c=comboDe(q);
    if(!c.length||c.some(function(x){ return !x.id; })||atc.disabled) return;
    atc.disabled=true; atc.classList.add('cargando');
    // giỏ đã có SP này → cộng dồn số món rồi xếp lại gói rẻ nhất (không để 2 dòng "1 cabezal" = đắt hơn gói 2)
    pedirJSON('cart.js')
      .then(function(cart){
        // bảo vệ bật + giỏ chưa có → thêm SL 1 trong CÙNG lần /cart/add.js; đã có → không thêm (luôn 1/đơn)
        var ex=(PROT&&PROT.on&&!(cart.items||[]).some(esProt))?[{id:+PROT.id,quantity:1}]:[];
        ex=liqItems().concat(ex);   // món xả kho đang chọn trên trang → vào giỏ cùng lần
        // COL: màu từng món = màu các món đã có trong giỏ + màu đang chọn trên trang → chia lại sau khi gộp gói
        var sel=COL?colSel(q):null, cols=null;
        if(COL){ cols=[]; colDeGiro(cart).forEach(function(o){ cols=cols.concat(o.cols); }); cols=cols.concat(sel); }
        var U=unidadesDe(cart), pr=U>0?fijarUnidades(cart,U+q,ex,cols):null;
        var rep=COL?colReparto(c,sel):[];
        return pr||pedirJSON('cart/add.js',{items:c.map(function(x,i){ return itemDe(x,rep[i]); }).concat(ex)}).then(function(){ return pedirJSON('cart.js'); });
      })
      .then(function(cart){
        pintarCarrito(cart);
        try{ if(window.fbq) fbq('track','AddToCart',{value:precioDe(q),currency:'EUR',num_items:q,content_name:tituloDe(q)}); }catch(err){}
        atc.textContent='✓ '+(atc.getAttribute('data-ok')||'');
        setTimeout(function(){ atc.textContent=atc.getAttribute('data-txt'); },2500);
        if(!abrirCarrito()) window.location.href=raiz+'cart';
      })
      .catch(function(){ atc.textContent=atc.getAttribute('data-txt'); })
      .then(function(){ atc.disabled=false; atc.classList.remove('cargando'); });
  });
})();

(function(){
  var toast=document.getElementById('toast'); if(!toast) return;
  var av=document.getElementById('toast-av'), t1=document.getElementById('toast-t1'), t2=document.getElementById('toast-t2');
  var closed=false;
  document.getElementById('toast-x').addEventListener('click',function(){ closed=true; toast.classList.remove('ver'); });

  var IC={
    envio:'<svg viewBox="0 0 24 24" fill="none" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2.8 6h11.4v10.5H2.8z" fill="#6CCF8E"/><path d="M14.2 9.5h4l3 3.2v3.8h-7z" fill="#A9E4BF"/><circle cx="7" cy="17.8" r="2" fill="#2A2A2A"/><circle cx="17.2" cy="17.8" r="2" fill="#2A2A2A"/><path d="M16 9.5v3h5" stroke-width="1.1"/></svg>',
    bateria:'<svg viewBox="0 0 24 24" fill="none" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5z" fill="#5CC48A"/><rect x="8.3" y="12.3" width="7.4" height="4.6" rx=".9" fill="#FFD84D"/></svg>',
    garantia:'<svg viewBox="0 0 24 24" fill="none" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.6 4.6 5.4v6c0 4.6 3.1 8.1 7.4 9.8 4.3-1.7 7.4-5.2 7.4-9.8v-6z" fill="#7ED3A0"/><path d="m8.8 12.2 2.3 2.3 4.3-4.6" stroke-width="1.9"/></svg>',
    pago:'<svg viewBox="0 0 24 24" fill="none" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6.3 3.6h3.1l1.6 4-2 1.2a11 11 0 0 0 5.2 5.2l1.2-2 4 1.6v3.1a1.7 1.7 0 0 1-1.9 1.7A16.6 16.6 0 0 1 4.6 5.5a1.7 1.7 0 0 1 1.7-1.9z" fill="#4C8DF5"/></svg>'
  };
  var SERVICIOS=[
    {svg:IC.envio,    t1:'Envío gratis', t2:' en todos los pedidos'},
    {svg:IC.bateria,  t1:'Pagas al recibir', t2:' — sin adelantar nada'},
    {svg:IC.garantia, t1:(toast.getAttribute('data-gar')||'30 días'), t2:' para probarlo en casa'},
    {svg:IC.pago,     t1:'Nos pondremos en contacto', t2:' para confirmar en 24 h'}
  ];
  /* ngôn ngữ trang (window.ORV_L do orv-lp.liquid in khi idioma = pt, 29/10/2026) — không có → tiếng Tây Ban Nha như cũ */
  var OL=window.ORV_L||null;
  if(OL && OL.servicios){ SERVICIOS.forEach(function(sv,k){ var x=OL.servicios[k]; if(!x) return; if(x[0]) sv.t1=x[0]; else if(k===2) sv.t1=(toast.getAttribute('data-gar')||OL.gar||sv.t1); sv.t2=x[1]; }); }
  var PEDIDOS=[
    {n:'Álvaro',c:'Madrid'},
    {n:'Beatriz',c:'Barcelona'},
    {n:'Gonzalo',c:'Valencia'},
    {n:'Patricia',c:'Sevilla'},
    {n:'Adrián',c:'Málaga'},
    {n:'Inés',c:'Zaragoza'},
    {n:'Hugo',c:'Bilbao'},
    {n:'Clara',c:'Murcia'},
    {n:'Marcos',c:'Salamanca'},
    {n:'Sara',c:'Alicante'},
    {n:'Rubén',c:'Valladolid'},
    {n:'Eva',c:'Granada'},
    {n:'Iván',c:'Córdoba'},
    {n:'Nuria',c:'Vigo'},
    {n:'Enrique',c:'Pamplona'},
    {n:'Miriam',c:'Santander'},
    {n:'Víctor',c:'Oviedo'},
    {n:'Cristina',c:'Gijón'},
    {n:'Héctor',c:'Vitoria-Gasteiz'},
    {n:'Lorena',c:'Castellón'}
  ];

  if(OL && OL.pedidos){ PEDIDOS=OL.pedidos.map(function(x){ return {n:x[0],c:x[1]}; }); }

  // ===== AVISOS DE PEDIDO (el contador de stock queda FIJO en 24 / 76) =====
  var EPOCH = Date.UTC(2026, 8, 10, 0,0,0);   // (2026, 8, 1) → (năm, THÁNG-1, ngày). VD 01/09/2026 = (2026, 8, 1)   // ancla: el nombre del pedido es igual para todos a la misma hora
  var SEG_POR_PEDIDO = 90;   // 1 đơn ảo mỗi 90 giây — tăng số này = đơn về chậm hơn                  // 1 aviso de pedido cada ~90 s
  function ordUnit(){ return Math.floor((Date.now()-EPOCH)/(SEG_POR_PEDIDO*1000)); }
  var lastOrd = ordUnit();

  function shuffle(a){ a=a.slice(); for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),t=a[i];a[i]=a[j];a[j]=t;} return a; }
  var servPool=shuffle(SERVICIOS), servIdx=0;
  function nextServ(){ if(servIdx>=servPool.length){ servPool=shuffle(SERVICIOS); servIdx=0; } return servPool[servIdx++]; }
  var AVCOLORS=['#3E7C6A','#C6803B','#4A6FA5','#9A5B8C','#5E8C4A','#B5573F'];
  function colorFor(str){ var h=0; for(var i=0;i<str.length;i++) h=(h*31+str.charCodeAt(i))>>>0; return AVCOLORS[h%AVCOLORS.length]; }
  function pedidoDe(u){ return PEDIDOS[((u%PEDIDOS.length)+PEDIDOS.length)%PEDIDOS.length]; }

  function pintarServ(d){ av.innerHTML=d.svg; av.style.background='var(--acento-tenue)'; av.style.color='var(--acento)';
    t1.textContent=d.t1; t2.textContent=d.t2; }
  // 03/11/2026 (theo Masify): ảnh đại diện thật cho từng tên (assets/toast-av-01..20.jpg, cùng thứ tự danh sách tên). Không có data-av → chữ cái đầu như cũ.
  var AV_URL=toast.getAttribute('data-av')||'';
  function pintarPedido(u){ var k=((u%PEDIDOS.length)+PEDIDOS.length)%PEDIDOS.length, p=PEDIDOS[k], na=k%20+1;
    if(AV_URL){ av.innerHTML='<img src="'+AV_URL.replace('NN',(na<10?'0':'')+na)+'" alt="" width="38" height="38" decoding="async">'; av.style.background='var(--fondo)'; }
    else { av.textContent=p.n.charAt(0).toUpperCase(); av.style.background=colorFor(p.n); av.style.color='#fff'; }
    t1.textContent=p.n+((OL&&OL.de)||' de ')+p.c; t2.textContent=(OL&&OL.pedido)||'acaba de hacer su pedido'; }

  // aviso de pedido → còn lại −1 (bộ đếm chung với hộp ưu đãi + thanh Bajo stock, xem "LÔ HÀNG" bên dưới)
  function vender(){ document.dispatchEvent(new CustomEvent('orv:venta')); }

  function beat(){
    if(closed) return;
    var u=ordUnit();
    if(u>lastOrd){ lastOrd=u; pintarPedido(u); vender(); }   // aviso de pedido -> baja el stock
    else { pintarServ(nextServ()); }               // mensaje de servicio
    toast.classList.add('ver');
    setTimeout(function(){ toast.classList.remove('ver'); }, 6000);
    setTimeout(beat, 6000 + 15000 + Math.random()*15000);   // 6s visible + 15-30s pausa (irregular)
  }
  setTimeout(beat, 6000);
})();

(function(){
  var bar=document.getElementById('sticky-cta'); if(!bar) return;
  // 01/10/2026 · PC: thanh dính trải FULL NGANG ngay từ khi hiện (sau hero), không chờ tới review/footer (CSS chỉ áp ≥1024px)
  bar.classList.add('ancho');
  // perf/orv-speed-05-10: KHÔNG đọc scrollY / body.scrollHeight / offsetHeight khi cuộn nữa (mỗi lần đọc = trình duyệt phải
  // tính lại layout ngay = forced reflow, PageSpeed báo ở dòng này). Cùng quy tắc như cũ, nhưng để trình duyệt tự báo:
  //  · mốc 560px: ô 1px đặt ở top 559px → ra khỏi khung nhìn phía trên = đã cuộn quá 560px
  //  · gần cuối trang (≤ 400px): ô 1px ở CUỐI body (margin-top −1px → không đổi chiều cao trang) vào vùng khung nhìn + 400px
  //  · chiều cao thanh (cho toast né lên): ResizeObserver — đo sau khi trình duyệt đã tự tính layout, không ép.
  if(window._orvDockOff) window._orvDockOff();   // Theme Editor tải lại section → bỏ bộ theo dõi của lần trước
  if('IntersectionObserver' in window && 'ResizeObserver' in window){
    var css='position:absolute;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden';
    var mTop=document.createElement('div'), mFin=document.createElement('div');
    mTop.setAttribute('aria-hidden','true'); mFin.setAttribute('aria-hidden','true');
    mTop.style.cssText=css+';top:559px';
    mFin.style.cssText='height:1px;margin-top:-1px;pointer-events:none;visibility:hidden';
    document.body.appendChild(mTop); document.body.appendChild(mFin);
    var pasado=false, fin=false, hBar=0, ver=null;
    function pintar(){
      var show=pasado && !fin;
      if(show!==ver){
        ver=show;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show?'false':'true');
      }
      document.documentElement.style.setProperty('--dock-h', (show?hBar:0)+'px');
    }
    var ioTop=new IntersectionObserver(function(es){
      var e=es[es.length-1]; pasado=!e.isIntersecting && e.boundingClientRect.top<0; pintar();
    });
    var ioFin=new IntersectionObserver(function(es){
      fin=es[es.length-1].isIntersecting; pintar();
    },{rootMargin:'0px 0px 400px 0px'});
    var roBar=new ResizeObserver(function(es){
      var e=es[es.length-1], b=e.borderBoxSize && (e.borderBoxSize[0]||e.borderBoxSize);
      hBar=Math.round(b && b.blockSize!=null ? b.blockSize : bar.offsetHeight);
      if(ver) pintar();
    });
    ioTop.observe(mTop); ioFin.observe(mFin); roBar.observe(bar);
    window._orvDockOff=function(){ ioTop.disconnect(); ioFin.disconnect(); roBar.disconnect(); mTop.remove(); mFin.remove(); };
    return;
  }
  // trình duyệt cũ (không có IntersectionObserver / ResizeObserver): cách cũ — đọc trước, ghi sau, trong requestAnimationFrame
  var cho=false;
  function upd(){
    cho=false;
    var y=window.scrollY||window.pageYOffset||0;
    var nearBottom=(window.innerHeight+y)>(document.body.scrollHeight-400);
    var show=y>560 && !nearBottom;
    // day toast len tren thanh sticky. Do offsetHeight that (nut xuong 2 dong,
    // safe-area khac nhau deu dung) thay vi hardcode chieu cao. (.show chỉ đổi transform → chiều cao không đổi)
    var h=show ? bar.offsetHeight : 0;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show?'false':'true');
    document.documentElement.style.setProperty('--dock-h', h+'px');
  }
  function pedir(){ if(!cho){ cho=true; window.requestAnimationFrame(upd); } }
  window.addEventListener('scroll', pedir, {passive:true});
  window.addEventListener('resize', pedir, {passive:true});
  pedir();
})();

/* Giỏ hàng + khối giá lớn bám theo số lượng đang chọn.
   Đọc lại từ DOM mà template đã cập nhật (#uds-n) → không phải sửa JS gốc. */
(function(){
  var n=document.getElementById('uds-n');
  var antes=document.getElementById('pc-antes'), ahora=document.getElementById('pc-ahora'),
      badge=document.getElementById('pc-badge');
  if(!n) return;
  function eur(v){ return v.toFixed(2).replace('.',',')+' €'; }
  function precioDe(q){ return totalDe(comboDe(q)); }
  // giá gạch = "Compare-at price" của variant (data-antes, do Liquid in ra từ Shopify):
  // gói N → variant của gói · đơn giá → compare-at × số lượng · ghép gói → tổng compare-at · thiếu → 0 (ẩn)
  function refDe(q){ return antesDe(comboDe(q)); }
  function pintar(){
    var q=parseInt(n.textContent,10)||1;
    var ref=refDe(q), hoy=precioDe(q);
    if(antes){ antes.textContent=ref>hoy?eur(ref):''; antes.style.display=ref>hoy?'':'none'; }
    if(ahora) ahora.textContent=eur(hoy);
    if(badge){
      var pct=ref>hoy?Math.round((1-hoy/ref)*100):0;
      badge.textContent=pct>0 ? ((window.ORV_L&&window.ORV_L.ahorra)||'AHORRA ')+pct+' %' : '';
      badge.style.display=pct>0?'':'none';
    }
    // ô số lượng: giá /ud theo số lượng đang chọn = giá gói ÷ số món của gói (không có gói → giá /ud của ô)
    var uEl=document.querySelector('.mas-pre .u[data-sufijo]');
    if(uEl){
      var r=packDe(q), k=r?(parseInt(r.getAttribute('data-uds'),10)||q):q;
      var pu=hoy/k, au=ref/k;
      uEl.textContent='';
      if(au>pu){ var sEl=document.createElement('s'); sEl.textContent=eur(au); uEl.appendChild(sEl); uEl.appendChild(document.createTextNode(' ')); }
      uEl.appendChild(document.createTextNode(eur(pu)+(uEl.getAttribute('data-sufijo')||'')));
    }
  }
  new MutationObserver(pintar).observe(n,{childList:true,characterData:true,subtree:true});
  pintar();
})();

/* Băng chuyền review: tự chạy, vòng lặp liền mạch, dừng khi khách tự vuốt */
(function(){
  var pista=document.getElementById('rv-pista'); if(!pista) return;
  var base=[].slice.call(pista.children);
  if(!base.length) return;
  base.forEach(function(c){ var k=c.cloneNode(true); k.setAttribute('aria-hidden','true'); pista.appendChild(k); });

  var media=window.matchMedia('(prefers-reduced-motion: reduce)');
  var anchoSet=0, timer=null, pausa=0;
  function medir(){
    anchoSet=0;
    for(var i=0;i<base.length;i++) anchoSet+=pista.children[i].getBoundingClientRect().width+10;
  }
  function paso(){
    var c=pista.children[0].getBoundingClientRect().width+10;
    pista.scrollBy({left:c, behavior:'smooth'});
  }
  function recentrar(){
    if(anchoSet && pista.scrollLeft>=anchoSet-1){
      var b=pista.style.scrollBehavior; pista.style.scrollBehavior='auto';
      pista.scrollLeft=pista.scrollLeft-anchoSet;
      pista.style.scrollBehavior=b;
    }
  }
  pista.addEventListener('scroll',function(){ window.requestAnimationFrame(recentrar); },{passive:true});
  ['touchstart','mousedown','wheel'].forEach(function(ev){
    pista.addEventListener(ev,function(){ pausa=Date.now(); },{passive:true});
  });
  function latir(){ if(Date.now()-pausa>4000) paso(); }
  function arrancar(){ medir(); if(!media.matches && !timer) timer=setInterval(latir,3500); }
  window.addEventListener('resize',medir);
  if(document.readyState==='complete') arrancar();
  else window.addEventListener('load',arrancar);

  var izq=document.getElementById('rv-izq'), der=document.getElementById('rv-der');
  function manual(d){ pausa=Date.now();
    var c=pista.children[0].getBoundingClientRect().width+10;
    pista.scrollBy({left:d*c, behavior:'smooth'}); }
  if(izq) izq.addEventListener('click',function(){manual(-1)});
  if(der) der.addEventListener('click',function(){manual(1)});
})();

/* VIDEO NGOÀI HERO: chỉ tải + chạy khi vào khung nhìn (cách 200px), ra khỏi khung nhìn → pause.
   Video ở tab đang ẩn / ô cuộn ngang chưa tới = không nhìn thấy → chưa tải. */
(function(){
  var vs=[].slice.call(document.querySelectorAll('video[data-src]')).filter(function(v){ return !v.closest('.pdp-media')&&!v.closest('.reel')&&!v.closest('[data-orv-rs]'); });
  if(!vs.length) return;
  if(!('IntersectionObserver' in window)){ vs.forEach(playVid); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting) playVid(v); else if(v.getAttribute('src')) v.pause(); });
  },{rootMargin:'200px 0px'});
  // ảnh bìa: gắn sớm hơn (cách 800px) để khách không thấy ô trống trước khi video chạy
  var ioP=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ posterVid(e.target); ioP.unobserve(e.target); } });
  },{rootMargin:'800px 0px'});
  vs.forEach(function(v){ io.observe(v); if(v.hasAttribute('data-poster')) ioP.observe(v); });
})();

/* VIDEO REVIEW (snippet orv-rs-card, 16/10/2026): chỉ tải + chạy khi thẻ hiện ≥ 50 % (thẻ ẩn sau "Ver más reseñas" = không
   hiện → chưa tải; mở ra rồi cuộn tới → chạy), ra khỏi khung → pause. Tối đa 3 video chạy cùng lúc (video cũ nhất dừng; khi 1 video
   ra khỏi khung, video đang hiện mà bị dừng chạy lại). Masonry chuyển thẻ sang cột khác → sự kiện orv:rs-armado → chạy lại video đang hiện. */
(function () {
  var vs = [].slice.call(document.querySelectorAll('[data-orv-rs] video[data-src]'));
  if (!vs.length) return;
  if (!('IntersectionObserver' in window)) { vs.forEach(posterVid); return; }
  var MAX = 3, activos = [];
  function on(v) {
    if (activos.indexOf(v) < 0) { activos.push(v); if (activos.length > MAX) activos.shift().pause(); }
    playVid(v);
  }
  function off(v) {
    var i = activos.indexOf(v); if (i >= 0) activos.splice(i, 1);
    if (v.getAttribute('src')) v.pause();
    vs.some(function (x) { if (x._orvVis && activos.indexOf(x) < 0) { on(x); return true; } return false; });
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; v._orvVis = e.isIntersecting && e.intersectionRatio >= 0.5; if (v._orvVis) on(v); else off(v); });
  }, { threshold: [0, 0.5] });
  var ioP = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { posterVid(e.target); ioP.unobserve(e.target); } });
  }, { rootMargin: '800px 0px' });
  vs.forEach(function (v) { io.observe(v); if (v.hasAttribute('data-poster')) ioP.observe(v); });
  document.addEventListener('orv:rs-armado', function () {
    activos.forEach(function (v) { if (v.paused) playVid(v); });
  });
})();

/* HÀNG REEL (lp_bloques tipo "reel", .reel): mỗi video chỉ tải + chạy khi THẺ của nó hiện ≥ 60 % (dọc lẫn ngang — khung cuộn
   ngang cắt phần thẻ khuất), dưới 60 % → pause. Ảnh bìa gắn sớm (cách 800px). PC (chuột): mũi tên ‹ › cuộn 1 thẻ, ẩn ở đầu/cuối. */
(function(){
  var reels=document.querySelectorAll('.reel'); if(!reels.length) return;
  var vids=[].slice.call(document.querySelectorAll('.reel video'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ var v=e.target.querySelector('video'); if(!v) return;
        if(e.isIntersecting&&e.intersectionRatio>=0.6) playVid(v); else if(v.getAttribute('src')) v.pause(); });
    },{threshold:[0,0.6,1]});
    var ioP=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ posterVid(e.target); ioP.unobserve(e.target); } });
    },{rootMargin:'800px'});
    document.querySelectorAll('.reel-it').forEach(function(f){ io.observe(f); });
    vids.forEach(function(v){ if(v.hasAttribute('data-poster')) ioP.observe(v); });
  } else vids.forEach(function(v){ posterVid(v); playVid(v); });
  reels.forEach(function(r){
    var t=r.querySelector('.reel-track'), iz=r.querySelector('.reel-fl.izq'), de=r.querySelector('.reel-fl.der');
    if(!t||!iz||!de) return;
    function paso(){ var f=t.querySelector('.reel-it'); return f?f.getBoundingClientRect().width+10:200; }
    function flechas(){
      var hay=t.scrollWidth>t.clientWidth+2;
      iz.hidden=!hay||t.scrollLeft<4; de.hidden=!hay||t.scrollLeft+t.clientWidth>=t.scrollWidth-4;
    }
    iz.addEventListener('click',function(){ t.scrollBy({left:-paso(),behavior:'smooth'}); });
    de.addEventListener('click',function(){ t.scrollBy({left:paso(),behavior:'smooth'}); });
    t.addEventListener('scroll',function(){ requestAnimationFrame(flechas); },{passive:true});
    if(window.ResizeObserver) new ResizeObserver(flechas).observe(t); else flechas();
  });
})();

/* Vùng TAB (khối "Tab"): bấm nút → hiện nhóm tương ứng, dừng/chạy video trong nhóm; đang cuộn sâu thì về đầu tab */
(function(){
  document.querySelectorAll('.tabs-zona').forEach(function(z){
    var btns=z.querySelectorAll('[data-tabbtn]'), grupos=z.querySelectorAll('.tab-grp');
    if(!btns.length) return;
    function show(n){
      btns.forEach(function(b){ b.setAttribute('aria-selected', b.getAttribute('data-tabbtn')===n?'true':'false'); });
      grupos.forEach(function(g){
        var on=g.getAttribute('data-tabgroup')===n; g.classList.toggle('tab-on',on);
        // tab ẩn → dừng video; tab hiện → video nào vào khung nhìn sẽ tự chạy (khối "VIDEO NGOÀI HERO" bên dưới)
        if(!on) g.querySelectorAll('video').forEach(function(v){ v.pause(); });
      });
    }
    function veAlInicio(){
      var dock=z.querySelector('.tabs-dock'), cab=document.querySelector('.cabecera');
      var hCab=cab?cab.offsetHeight:0;
      var destino=Math.round(dock.getBoundingClientRect().top+window.pageYOffset-hCab);
      if(window.pageYOffset>destino) window.scrollTo(0,destino);
    }
    btns.forEach(function(b){ b.addEventListener('click',function(){ show(b.getAttribute('data-tabbtn')); veAlInicio(); }); });
    z._orvTab=show;
    show('1');
  });
  // Theme Editor: chọn 1 khối nằm trong tab đang ẩn → mở tab đó
  document.addEventListener('shopify:block:select',function(e){
    var g=e.target.closest&&e.target.closest('.tab-grp'); if(!g) return;
    var z=g.closest('.tabs-zona'); if(z&&z._orvTab) z._orvTab(g.getAttribute('data-tabgroup'));
  });
})();

/* Đồng hồ đếm ngược one-time-offer: chạy tới 00:00 hôm nay (giờ máy khách) */
(function(){
  var D=document.getElementById('cd-d'), H=document.getElementById('cd-h'),
      M=document.getElementById('cd-m'), S=document.getElementById('cd-s');
  if(!H||!M||!S) return;
  function dd(n){ return (n<10?'0':'')+n; }
  function pintar(){
    var ahora=new Date();
    var fin=new Date(ahora.getFullYear(),ahora.getMonth(),ahora.getDate()+1,0,0,0,0);
    var s=Math.max(0,Math.floor((fin-ahora)/1000));
    if(D){ D.textContent=Math.floor(s/86400); H.textContent=dd(Math.floor(s/3600)%24); }
    else H.textContent=dd(Math.floor(s/3600));
    M.textContent=dd(Math.floor(s/60)%60);
    S.textContent=dd(s%60);
  }
  pintar(); setInterval(pintar,1000);
})();

(function(){
  /* ticker tự trượt */
  var tr=document.querySelector('.pr-track'); if(tr){
    var n=tr.children.length, i=0, t;
    function go(k){ i=(k+n)%n; tr.style.transform='translateX(-'+(i*100)+'%)'; }
    function auto(){ clearInterval(t); t=setInterval(function(){go(i+1)},3500); }
    document.querySelectorAll('.pr-arr').forEach(function(b){ b.addEventListener('click',function(){ go(i+ (+b.getAttribute('data-pr'))); auto(); }); });
    auto();
  }
  /* timeline: ngày theo máy khách, đếm NGÀY LÀM VIỆC (bỏ thứ 7, CN) — "1-2 días laborables" */
  var M=(window.ORV_L&&window.ORV_L.meses)||['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function d(n){ var x=new Date(); while(n>0){ x.setDate(x.getDate()+1); var w=x.getDay(); if(w!==0&&w!==6) n--; } return x.getDate()+' '+M[x.getMonth()]; }
  document.querySelectorAll('[data-tl]').forEach(function(el){
    var r=el.getAttribute('data-tl').split('-'), a=+r[0], b=+r[1];
    el.textContent = a===b ? d(a) : d(a)+' – '+d(b);
  });
  /* timeline sáng lần lượt (lặp: 3 bước × 1,1 s, giữ 2,6 s, tắt, chạy lại) */
  var cs=document.querySelectorAll('#tl-cod .tl-c'), ts=document.querySelectorAll('.trust-top.t4 .t3');
  if(cs.length && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    function run(){
      cs.forEach(function(c){c.classList.remove('on')});
      cs.forEach(function(c,k){ setTimeout(function(){ c.classList.add('on'); }, 400+k*1100); });
      var t0=400+3*1100+600;                       /* trust bắt đầu sau khi timeline sáng hết + 0,6 s */
      ts.forEach(function(t,k){ setTimeout(function(){ t.classList.add('zoom'); setTimeout(function(){t.classList.remove('zoom')},700); }, t0+k*750); });
      setTimeout(run, t0+4*750+2200);
    }
    run();
  } else { cs.forEach(function(c){c.classList.add('on')}); }

  /* LÔ HÀNG: hộp ưu đãi (đã bán #lote-pedidos · còn lại #lote-quedan) + mọi thanh Bajo stock [data-stock]
     dùng CHUNG 1 bộ đếm: lô (data-lote) + còn lại (data-quedan, do Liquid in từ settings / lp_config).
     Mỗi toast "acaba de hacer su pedido" (sự kiện orv:venta) → còn lại −1, đã bán +1, thanh = đã bán / lô.
     Nhớ trong phiên (sessionStorage theo trang) · không xuống dưới DISP_MIN. */
  (function(){
    var bars=document.querySelectorAll('[data-stock]');
    var elQ=document.getElementById('lote-quedan'), elP=document.getElementById('lote-pedidos');
    var src=bars[0]; if(!src) return;
    var LOTE=parseInt(src.getAttribute('data-lote'),10)||100, DISP_MIN=3;
    var disp=parseInt(src.getAttribute('data-quedan'),10); if(isNaN(disp)) disp=24;
    var Q0=disp, VEND0=elP?parseInt(elP.getAttribute('data-base'),10):NaN;   // số đã bán riêng từng trang (Liquid) + số đơn từ đầu phiên
    var KEY='orv_q:'+location.pathname;
    try{ var sv=parseInt(sessionStorage.getItem(KEY),10); if(!isNaN(sv)) disp=Math.max(DISP_MIN,Math.min(disp,sv)); }catch(e){}
    function animarNum(el,to){ if(!el)return; var from=parseInt(el.textContent,10); if(isNaN(from))from=to;
      if(from===to){ el.textContent=to; return; } var dir=to>from?1:-1,cur=from;
      var iv=setInterval(function(){ cur+=dir; el.textContent=cur; if(cur===to) clearInterval(iv); },90); }
    function paint(anim){
      var pct=Math.round((LOTE-disp)*100/LOTE);
      bars.forEach(function(b){ b.querySelector('.stock-bar i').style.width=pct+'%'; b.querySelector('[data-stock-n]').textContent=pct; });
      var vend=isNaN(VEND0)?LOTE-disp:VEND0+(Q0-disp);
      if(anim){ animarNum(elQ,disp); animarNum(elP,vend); }
      else { if(elQ) elQ.textContent=disp; if(elP) elP.textContent=vend; }
    }
    document.addEventListener('orv:venta',function(){
      if(disp<=DISP_MIN) return; disp--; try{sessionStorage.setItem(KEY,disp)}catch(e){} paint(true);
    });
    paint(false);
  })();
})();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',orvLP); else orvLP();
document.addEventListener('shopify:section:load',function(e){ if(e.target.querySelector('.lienzo')) orvLP(); });
})();


/* REVIEW masonry (sections/orv-lp-resenas.liquid) — chuyển từ {% javascript %} ra đây 03/10/2026 (trước nằm trong compiled scripts.js) */
  (function () {
    /* orv-speed-05-10: matchMedia thay window.innerWidth — đọc innerWidth ngay sau khi CSS vừa áp = ép tính layout cả trang
       (PageSpeed: forced reflow 78 ms). Media query cùng mốc bề rộng (gồm thanh cuộn, như innerWidth) nhưng không ép layout. */
    var mqPC = window.matchMedia('(min-width: 1024px)'), mqTab = window.matchMedia('(min-width: 640px)');
    function cols() {
      return mqPC.matches ? 4 : mqTab.matches ? 3 : 2;
    }
    /* Chạy fn SAU khi trình duyệt tự tính layout (callback ResizeObserver: layout đã xong, chưa vẽ) → đọc kích thước
       không ép reflow, và chia cột xong trước khi vẽ nên không thấy cảnh thẻ dồn 1 cột. */
    function trasLayout(el, fn) {
      if (!('ResizeObserver' in window)) { fn(); return; }
      var ro = new ResizeObserver(function () { ro.disconnect(); fn(); });
      ro.observe(el);
    }
    /* Masonry: chia thẻ đang hiện vào N cột, thẻ kế tiếp vào cột đang thấp nhất (giữ thứ tự đọc theo hàng).
       perf/lp-v4: đo chiều cao MỌI thẻ 1 lần (đặt tạm cả vào cột 1 — các cột rộng bằng nhau) rồi chia bằng phép cộng,
       thay vì đọc offsetHeight sau mỗi lần chuyển thẻ (forced reflow). Cột cao = tổng thẻ + gap giữa các thẻ (như offsetHeight). */
    function armar(grid) {
      var cards = grid._orvCards;
      var n = cols();
      grid.querySelectorAll('.orv-rs-col').forEach(function (c) { c.remove(); });
      var columnas = [];
      for (var i = 0; i < n; i++) {
        var c = document.createElement('div');
        c.className = 'orv-rs-col';
        grid.appendChild(c);
        columnas.push(c);
      }
      grid.classList.add('is-mas');
      var vis = [];
      cards.forEach(function (card) {
        if (card.hidden) { grid.appendChild(card); return; }
        columnas[0].appendChild(card);
        vis.push(card);
      });
      grid._orvN = n;
      var tok = grid._orvTok = (grid._orvTok || 0) + 1;   // lần xếp mới hơn (ảnh tải xong, đổi cỡ màn) → bỏ lần cũ đang chờ
      trasLayout(columnas[0], function () {
        if (tok !== grid._orvTok) return;
        var gap = parseFloat(getComputedStyle(columnas[0]).rowGap) || 0;
        var hs = vis.map(function (card) { return card.getBoundingClientRect().height; });
        var suma = columnas.map(function () { return 0; }), cuenta = columnas.map(function () { return 0; });
        function alto(k) { return cuenta[k] ? Math.round(suma[k] + gap * (cuenta[k] - 1)) : 0; }
        vis.forEach(function (card, j) {
          var min = 0;
          for (var k = 1; k < n; k++) if (alto(k) < alto(min)) min = k;
          columnas[min].appendChild(card);
          suma[min] += hs[j];
          cuenta[min]++;
        });
        grid.dispatchEvent(new CustomEvent('orv:rs-armado', { bubbles: true }));   // video review: chạy lại video đang hiện sau khi chuyển cột
      });
    }
    /* orv-lp.css nạp không chặn (layout orv-lp): chỉ xếp masonry khi CSS đã áp (html.orv-css / sự kiện orv:css),
       nếu không chiều cao đo được là của thẻ chưa có CSS. */
    function trasCss(fn) {
      if (!document.querySelector('link[data-orv-css]') || document.documentElement.classList.contains('orv-css')) fn();
      else document.addEventListener('orv:css', fn, { once: true });
    }
    function init(sec) {
      if (!sec || sec._orvRs) return;
      sec._orvRs = true;
      var grid = sec.querySelector('[data-orv-rs-grid]');
      if (!grid) return;
      grid._orvCards = Array.prototype.slice.call(grid.querySelectorAll('.orv-rs-card'));
      var btn = sec.querySelector('[data-orv-rs-mas]');
      if (btn) {
        btn.addEventListener('click', function () {
          grid._orvCards.forEach(function (c) { c.hidden = false; });
          btn.parentNode.hidden = true;
          armar(grid);
        });
      }
      trasCss(function () { armar(grid); });
      /* ảnh tải xong làm thẻ cao lên → xếp lại một lần */
      grid.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { armar(grid); }, { once: true });
      });
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { if (cols() !== grid._orvN) armar(grid); }, 150);
      });
    }
    function all() { document.querySelectorAll('[data-orv-rs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-orv-rs]')); });
  })();

/* TRƯỚC / SAU có thanh trượt (snippet orv-lp-bloque, .ba-cmp): input range = giá trị → --pos.
   Chuột / chạm: kéo ngang ở bất kỳ đâu trên ảnh (pointer events; vuốt dọc vẫn cuộn trang nhờ touch-action:pan-y).
   Bàn phím: mũi tên trên input range. Uỷ quyền sự kiện ở document → chạy cả khi Theme Editor tải lại section. */
(function () {
  function ponerPos(box, v) {
    v = Math.max(0, Math.min(100, v));
    var r = box.querySelector('.ba-rng');
    if (r) r.value = Math.round(v);
    box.style.setProperty('--pos', v + '%');
  }
  function desdeX(box, x) {
    var b = box.getBoundingClientRect();
    if (b.width) ponerPos(box, (x - b.left) / b.width * 100);
  }
  document.addEventListener('input', function (e) {
    var r = e.target;
    if (r.classList && r.classList.contains('ba-rng')) r.parentNode.style.setProperty('--pos', r.value + '%');
  });
  var activo = null;
  document.addEventListener('pointerdown', function (e) {
    var box = e.target.closest && e.target.closest('.ba-cmp');
    if (!box || (e.pointerType === 'mouse' && e.button !== 0)) return;
    activo = { box: box, id: e.pointerId, x: e.clientX, y: e.clientY, mov: e.pointerType === 'mouse' };
    if (activo.mov) { e.preventDefault(); desdeX(box, e.clientX); }
  });
  document.addEventListener('pointermove', function (e) {
    if (!activo || e.pointerId !== activo.id) return;
    if (!activo.mov) {
      /* chạm: chỉ coi là kéo khi vuốt ngang rõ hơn vuốt dọc */
      var dx = Math.abs(e.clientX - activo.x), dy = Math.abs(e.clientY - activo.y);
      if (dx < 6 && dy < 6) return;
      if (dy > dx) { activo = null; return; }
      activo.mov = true;
    }
    desdeX(activo.box, e.clientX);
  });
  function fin(e) {
    if (!activo || e.pointerId !== activo.id) return;
    if (!activo.mov && e.type === 'pointerup') desdeX(activo.box, e.clientX); /* chạm nhẹ = nhảy tới chỗ chạm */
    activo = null;
  }
  document.addEventListener('pointerup', fin);
  document.addEventListener('pointercancel', fin);
})();

/* REGALOS INCLUIDOS (lp_config.regalos): nút "Ver ▼ / Ocultar ▲" trong thẻ gói mở/đóng panel #rgs-panel (mặc định thu gọn).
   Nút nằm trong <label> của gói → preventDefault để không đổi gói khi bấm. Mọi nút cùng aria-controls được đồng bộ aria-expanded + chữ. */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.rgs-tog'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var p=document.getElementById(b.getAttribute('aria-controls')); if(!p) return;
    var abrir=p.hidden; p.hidden=!abrir;
    document.querySelectorAll('.rgs-tog[aria-controls="'+p.id+'"]').forEach(function(t){
      t.setAttribute('aria-expanded',abrir?'true':'false');
      t.textContent=t.getAttribute(abrir?'data-ocultar':'data-ver');
    });
  });
})();
